{
    "Api tokens": {
        "add token": "토큰 추가",
        "description": "TCT 및 Configurator용 OEM 파일 다운로드를 위한 API 토큰 또는 FOTA WEB 서비스 요청 시 애플리케이션이 사용할 API 토큰을 생성합니다. API 문서는 <1>여기</1>에서 확인할 수 있습니다.",
        "example": "예: fota_token",
        "generate token": "토큰 생성",
        "generated token": "생성된 토큰",
        "last used at": "마지막으로 사용된 위치:",
        "name": "토큰 이름",
        "never": "절대",
        "no tokens": "사용 가능한 토큰이 없습니다",
        "no tokens description": "토큰이 추가되면 아래에 목록으로 표시됩니다",
        "show token list": "토큰 목록 표시",
        "titles": {
            "Integration": {
                "description": "시스템 내 FOTA WEB 통합에 사용됩니다",
                "name": "API 통합 토큰"
            },
            "Tct": {
                "description": "TCT 및 Configurator용 OEM 파일 다운로드에 사용됩니다",
                "name": "TCT 토큰"
            }
        },
        "tokens": "API 토큰",
        "token type": "토큰 유형",
        "token was created": "토큰이 성공적으로 생성되었습니다"
    },
    "Attributes": {
        "Completed": "완료됨",
        "Count": "카운트",
        "Current": "현재",
        "Date": "날짜",
        "Empty": "빈",
        "excluded files": "제외된 파일 (동일 등급)",
        "Failed": "실패",
        "false": "",
        "Feature": "기능",
        "file size bytes": "총 파일 크기",
        "File_type": "파일 유형",
        "File_version": "파일 버전",
        "Fingerprint_id": "지문 인식",
        "Firmware_date": "펌웨어 날짜",
        "Firmware_version": "개정판",
        "included files": "포함된 파일",
        "Include_j1939": "",
        "Message": "메시지",
        "Metadata": "",
        "newest": "최신 버전부터",
        "oldest": "가장 오래된 것부터",
        "Order": "주문",
        "Password_source": "",
        "Pending": "보류 중",
        "Period": "기간",
        "Process_id": "",
        "Protocol_id": "프로토콜 ID",
        "Reported_count": "",
        "Requested_count": "",
        "specific": "특정",
        "Start": "시작",
        "SystemGenerated": "",
        "true": "",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "BLE 펌웨어",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "CAN 펌웨어",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "TAPP 펌웨어"
        },
        "UserEntered": "",
        "vehicle": "차량",
        "Vehicle_id": "차량 ID",
        "Vin": "차량 식별 번호(VIN)"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "인증 앱을 확인하세요",
            "check email": "이메일을 확인하세요",
            "code required": "인증 코드가 필요합니다.",
            "code sent to email": "이메일로 발송된 코드",
            "code valid": "해당 코드는 몇 분 동안 유효합니다.",
            "enter code below": "아래 코드를 입력하여 로그인하세요.",
            "no access to otp": "",
            "recovery code": {
                "banner text": "",
                "description": "",
                "secondary text": "",
                "title": ""
            },
            "title": "",
            "use recovery code": ""
        },
        "account verification description": "인증 코드가 필요합니다. 인증 앱을 확인하고 아래에 코드를 입력하여 로그인하세요.",
        "check email": "수신된 링크를 클릭하여 비밀번호를 재설정해 주십시오.",
        "community forum": "크라우드 지원 포럼",
        "contact us": "문의하기",
        "create initial password": "비밀번호 생성",
        "create password": "비밀번호 생성",
        "did not receive": "링크를 받지 못하셨나요?",
        "do not have account": "아직 계정이 없으신가요?",
        "email": "이메일",
        "enter email": "비밀번호 재설정 안내를 받으시려면 아래에 등록된 이메일을 입력해 주세요.",
        "forgot password": "비밀번호를 잊으셨나요?",
        "forgot your password": "비밀번호를 잊으셨나요?",
        "for ms365": "Teltonika MS365 사용자용",
        "invalid email format": "잘못된 이메일 형식",
        "invalid password format": "비정상적인 비밀번호 형식",
        "link sent": "링크가 전송되었습니다!",
        "length": "최소 8자",
        "lowercase": "소문자 글자 1개 이상 포함",
        "new password": "새 비밀번호",
        "password": "비밀번호",
        "passwords do not match": "비밀번호가 일치하지 않습니다",
        "privacy policy": "FOTA WEB을 사용함으로써 귀하는 당사의 <1>개인정보 처리방침</1>에 동의하는 것으로 간주됩니다.",
        "remember password": "비밀번호를 기억하시나요?",
        "repeat password": "비밀번호 재입력",
        "required": "필요 사항",
        "resend": "재전송",
        "reset password": "비밀번호 재설정",
        "send reset link": "초기화 링크 보내기",
        "sign in": "로그인",
        "sign in to fota": "FOTA WEB 계정에 로그인하세요",
        "signup": "가입하기",
        "sso": "Microsoft 계정으로 로그인",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "대문자",
        "user consent text": "저는 Teltonika <1>서비스 약관</1> 및 <2>데이터 처리 계약</2>을 이해하고 수락합니다.",
        "welcome": "환영합니다",
        "wiki": "텔레매틱스 위키 지식 기반"
    },
    "Banner": {
        "activate banner": "",
        "apply link": "",
        "banner importance": "",
        "bold": "",
        "close link": "",
        "info": "",
        "italic": "",
        "link": "",
        "message": "",
        "text": "",
        "underline": "",
        "url": "",
        "warning": ""
    },
    "Button": {
        "accept": "수락",
        "accept all": "모두 수락",
        "accept selected": "선택한 항목 수락",
        "actions": "활동",
        "add": "추가",
        "add device": "기기 추가",
        "add more files": "더 많은 파일 추가",
        "add new": "새로 추가",
        "agree": "동의합니다",
        "all companies": "모든 기업",
        "all of company": "{{companyName}} 전체",
        "all rows selected": {
            "devices": "{{count}}개의 모든 기기가 선택되었습니다",
            "tasks": "모든 {{count}}개의 대기 중/실행 중인 작업이 선택되었습니다",
            "groups": "{{count}}개 그룹 모두 선택됨",
            "files": "{{count}}개의 파일이 모두 선택되었습니다",
            "companies": "{{count}}개 기업 모두 선택됨",
            "users": "{{count}}명의 모든 사용자가 선택되었습니다"
        },
        "approve": "승인",
        "assign": "할당",
        "assigning": "할당",
        "auto sync": "",
        "back": "뒤로",
        "back to sign in": "로그인으로 돌아가기",
        "cancel": "취소",
        "cancelling": "취소",
        "cancel all tasks in group": "그룹 내 모든 업무 취소",
        "cancel tasks": "업무 취소",
        "cannot create desktop licenses": "내부 회사에 대해서는 라이선스를 생성할 수 없습니다.",
        "cannot create offline licenses": "제한 없는 라이선스에 대해서는 오프라인 라이선스를 생성할 수 없습니다.",
        "change": "변경",
        "clear all": "모두 지우기",
        "clear all filters": "모든 필터 지우기",
        "close": "닫기",
        "company settings": "회사 설정",
        "confirm": "확인",
        "continue": "계속",
        "copied": "복사됨",
        "copy all": "",
        "copy to clipboard": "클립보드에 복사",
        "create": "만들기",
        "create role": "역할 만들기",
        "create task": "업무 생성",
        "creating": "생성",
        "default view": "기본 보기",
        "delete": "삭제",
        "deleting": "삭제",
        "deselect all": "모두 선택 해제",
        "device": "기기",
        "disable": "비활성화",
        "disagree": "동의하지 않습니다",
        "discard": "Discard",
        "download": "",
        "edit": "편집",
        "enable": "활성화",
        "export": "내보내기",
        "exporting": "내보내기",
        "filters": "필터",
        "finish": "",
        "find tool": "도구 찾기",
        "first page": "첫 페이지",
        "generate": "생성",
        "generate codes": "",
        "go back": "뒤로 가기",
        "import": "가져오기",
        "importing": "가져오기",
        "invite": "초대",
        "invite user": "사용자 초대",
        "invite user to internal disabled": "관리자 관리자(Admin Manager) 이상의 접근 권한을 가진 사용자만 내부 회사에 사용자를 초대할 수 있습니다.",
        "language": "언어",
        "last page": "마지막 페이지",
        "logout": "로그아웃",
        "maximize details": "최대한 상세히",
        "merge": "병합",
        "merging": "병합",
        "minimize details": "세부 사항 최소화",
        "more actions": "추가 활동",
        "more filters": "추가 필터",
        "more options": "추가 옵션",
        "move": "이동",
        "moving": "이동",
        "next": "다음",
        "next month": "다음 달",
        "next page": "다음 페이지",
        "no actions available": "사용 가능한 활동 없음",
        "no permission": "\"{{permissionName}}\" 권한이 필요합니다.",
        "no permissions": "다음 권한이 필요합니다: {{permissionNames}}.",
        "notify when done": "완료 시 알림 받기",
        "number of selected companies": "{{companyName}}의 {{companyCount}}",
        "only essential": "필수 기능만",
        "open fota web": "오픈 FOTA WEB",
        "pages of": "/{{total}}",
        "previous month": "지난 달",
        "previous page": "이전 페이지",
        "print": "",
        "receive devices": "기기 수신",
        "refresh page": "새로 고침",
        "reject all": "모두 거부",
        "reset to default": "기본값으로 재설정",
        "retry failed tasks": "실패한 업무 재시도",
        "retrying": "재시도 중",
        "return home": "집에 가자",
        "revert manual level change": "수동 레벨 변경을 되돌리기",
        "rows count per page": "페이지당 행 수",
        "rows selected": "{{count}} 선택됨",
        "save": "저장",
        "saving": "",
        "see all": "모두 보기",
        "select all": {
            "devices": "{{count}}개의 기기 모두 선택",
            "tasks": "{{count}}개의 대기 중/실행 중인 업무 모두 선택",
            "groups": "{{count}}개 그룹 모두 선택",
            "files": "{{count}}개 파일 모두 선택",
            "companies": "{{count}}개 기업 모두 선택",
            "users": "{{count}}명의 사용자 모두 선택"
        },
        "select columns to show": "표시할 열 선택",
        "selected page is first": "선택한 페이지는 첫 번째 페이지입니다",
        "selected page is last": "선택된 페이지는 마지막 페이지입니다",
        "select rows": "행 선택",
        "send code": "코드 전송",
        "settings": "설정",
        "show me": "보여주세요",
        "show more": "더 보기",
        "synchronize": "동기화",
        "table statistics": "테이블 통계",
        "table view": "테이블 보기",
        "transfer": "이체",
        "transferring": "이체",
        "transfer my devices": "내 기기 이체",
        "undo": "실행 취소",
        "upload": "업로드",
        "upload file": "새 파일 업로드",
        "user": "사용자",
        "verify": "확인",
        "yes": "예"
    },
    "Cookies": {
        "always active": "항상 활성화됨",
        "analytics cookies": "분석 쿠키",
        "analytics cookies description": "이러한 추적기는 분석을 위해 사용되며, 사용자가 당사 웹사이트와 상호작용하는 방식을 이해할 수 있도록 데이터를 수집하는 데 도움이 됩니다. 이러한 통찰력을 통해 콘텐츠를 개선하고 사용자 경험을 향상시키는 더 나은 기능을 구축할 수 있습니다. 이 범주의 쿠키는 비활성화할 수 있습니다.",
        "cookie banner message": "당사와 선정된 제3자는 기술적 목적을 위해 쿠키 또는 유사 기술을 사용하며, 귀하의 동의 하에 정책에 명시된 기타 목적으로도 사용합니다. ",
        "cookie modal title": "쿠키를 사용합니다",
        "cookie policy": "쿠키 정책",
        "essential cookies": "필수 쿠키",
        "essential cookies description": "이러한 추적기는 귀하가 당사에 요청한 서비스를 운영하거나 제공하기 위해 반드시 필요한 활동에 사용되며, 마케팅 목적으로 활용될 수 있는 귀하의 정보를 수집하지 않으며 인터넷에서 방문한 기록을 기억하지 않습니다. 이 범주의 쿠키는 비활성화할 수 없습니다."
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "원격 기기 업데이트를 위한 필수 요소",
                "Standard": "고급 자동화 및 통합",
                "Premium": "기업 확장성 및 업데이트 조기 접근"
            },
            "resource limit types": {
                "Companies": "기업",
                "Users": "사용자",
                "ConfigurationFiles": "구성 파일"
            }
        },
        "empty state": {
            "description": {
                "configurations": "FOTA WEB에서 설정이 감지되는 즉시, 여기에서 목록을 확인할 수 있습니다.",
                "firmware versions": "FOTA WEB에서 펌웨어 버전을 감지하는 즉시, 해당 목록을 여기서 확인할 수 있습니다."
            },
            "title": {
                "configurations": "구성 정보가 감지되지 않음",
                "firmware versions": "펌웨어 버전이 감지되지 않음",
                "news": "표시할 뉴스가 없습니다"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "오늘",
                "7": "7일",
                "30": "30일",
                "90": "90일"
            },
            "period": "기간"
        },
        "new": "",
        "news": {
            "body": {
                "1": "2025년 1월 7일 이후 초대된 사용자의 경우 계정 활성화 즉시 2단계 인증(2FA)이 의무화됨을 알려드립니다. 이메일 인증 또는 인증 앱을 통한 2단계 인증이 가능합니다.",
                "2": "2025년 6월 3일 05:00(UTC)부터 예정된 FOTA WEB 유지보수 일정을 알려드립니다. 유지보수 기간 동안 사용자 인터페이스, API 접근, 업무 실행, OBD 및 CAN 서비스를 포함한 모든 서비스가 이용 불가함을 유의하시기 바랍니다. 서비스 중단 예상 시간은 1시간입니다.",
                "3": "<section><p>FOTA WEB의 디바이스 잠금 해제 기능에 중요한 개선 사항이 적용되었음을 알려드립니다. </p></section> <section><p>이제 모든 사용자 역할에서 직접 디바이스 잠금을 해제할 수 있습니다. 헬프데스크를 통해 기술 지원팀에 문의할 필요가 없습니다!</p> <p>주요 내용:</p> <ul><li>사용자는 24시간 동안 동일한 디바이스의 잠금을 최대 3회까지 해제할 수 있습니다.</li> <li>한도에 도달하면 잠금 해제 옵션이 24시간 동안 일시적으로 비활성화됩니다.</li> <li>잠금 해제 한도를 초과하면 오류 메시지가 표시됩니다. 이 업데이트로 대기 시간이 크게 단축되고 차량 관리에 대한 통제력이 강화됩니다.</li></ul></section> <section><a>기능 사용 방법 알아보기</a></section>",
                "4": "<section><p>FOTA WEB 대시보드의 멋진 새 업데이트를 발표하게 되어 기쁩니다! 향상된 위젯과 새로운 인사이트로 사용자 경험을 개선하기 위해 노력해 왔습니다.</p></section><section><h3>신규 기기 통계</h3><p>두 가지 새로운 위젯으로 기기 활동에 대한 더 나은 통찰력을 얻으세요:</p><p><strong>활성화된 기기</strong>: 이 새로운 통계는 다양한 기간(오늘, 7일, 30일, 90일) 동안 활성화(연결)된 기기 수를 보여줍니다.</p><p><strong>가져온 기기</strong>: 마찬가지로, 새로운 '가져온 기기' 통계는 오늘, 7일, 30일 또는 90일 동안 가져온 기기 수를 추적합니다.</p></section><section><h3>업무 위젯 소개</h3><p>새롭게 선보이는 업무 위젯으로 운영 현황을 추적하세요:</p><p><strong>대기 중인 업무</strong>: 현재 처리 대기 중인 작업의 명확한 개수를 확인하세요.</p><p><strong>업무 개요</strong>: 기간(7일, 30일 또는 90일) 및 상태별 업무 분배 현황을 확인하세요. 여기에는 완료, 오류 발생 완료 또는 실패한 작업이 포함됩니다.</p></section><section><h3>스마트 펌웨어 및 구성 개요</h3><p>펌웨어 버전 및 구성 위젯을 개선했습니다:</p><ul><li>더 깔끔한 데이터를 위해 \"알 수 없음\" 통계 항목을 제거했습니다.</li><li>UI에서 펌웨어 및 구성 이름과 해당 개수를 더 명확하게 표시합니다.</li><li>최초로 상위 5개 버전 또는 구성이 표시되며, \"더 보기\" 옵션을 통해 최대 100개의 서로 다른 항목을 확인할 수 있습니다.</li><li>특정 펌웨어 또는 구성을 마우스로 가리키거나 클릭하면 \"기기 페이지\"로 이동하여 필터가 적용됩니다.</li></ul></section><section><h3>향상된 뉴스 위젯</h3><p>한눈에 최신 정보를 확인하세요! 뉴스 위젯이 새롭게 단장했으며, 이제 뉴스 항목을 클릭하면 전체 내용을 읽을 수 있습니다.</p></section><section><h3>개선된 장치 상태</h3><p>기기 상태 위젯이 시각적으로 개선되어 명확해졌습니다. 또한 이제 기기 상태 위에 마우스를 올려놓고 클릭하면 \"기기\" 페이지에서 해당 상태의 기기만 필터링할 수 있습니다.</p></section><section><p>이번 업데이트로 일상 업무가 더욱 수월해지고 유용한 정보를 제공받으시길 바랍니다. 여러분의 의견을 알려주세요!</p></section>",
                "5": "<section><h3>예정된 API 변경 사항</h3></section> <section><p>2025년 9월 24일, 사용자 엔터티를 반환하는 응답(예: GET /users 또는 GET /users/{userId} 엔드포인트)에서 \"role\" 필드를 제거할 예정입니다. 이 변경은 FOTA WEB에서 보다 강력하고 유연한 권한 시스템을 위한 기반을 마련하기 위한 것입니다.</p></section> <section><h3>미리 보기: 역할 및 권한</h3></section> <section><p>현재 역할 시스템이 여러분이 필요로 하는 유연성을 제공하지 못한다는 점을 인지하고 있습니다. 저희 개발팀은 권한을 세밀하게 제어할 수 있는 역할을 생성할 수 있는 새로운 <strong>역할 및 권한 관리</strong> 기능을 개발 중입니다.</p></section> <section><p>이 새로운 시스템을 통해 사용자에게 고정된 역할을 할당하거나 특정 요구 사항에 맞게 권한을 조정하고 사용자 정의 역할을 생성할 수 있습니다. 저희는 이 기능에 대해 매우 기대하고 있으며, 역할 및 권한 관리 기능이 제공될 때 더 자세한 내용을 공유할 수 있기를 고대합니다.</p></section>",
                "6": "<section><p>FOTA WEB 내에서 사용자 접근을 정밀하게 제어할 수 있도록 설계된 새로운 <strong>\"역할 및 권한\"</strong> 기능의 출시를 발표하게 되어 기쁘게 생각합니다. 이 기능을 통해 특정 <strong>권한</strong>(예: \"업무 생성\", \"사용자 초대\")의 집합인 <strong>역할</strong>을 사용하여 사용자 기능을 정의할 수 있습니다. 이 기능에는 기본 보안 수준을 위한 변경 불가능한 <strong>정적 역할</strong>(관리자, 사용자, 게스트)과 함께 <strong>프리미엄 회사 수준</strong> 사용자만 생성 또는 편집할 수 있는 사용자 정의 가능한 <strong>사용자 정의 역할</strong>이 포함됩니다. 권한은 이제 장치, 업무, 사용자 등 주요 영역별로 분류되며, 관리 섹션에서 \"권한 수\"에 마우스를 올리면 확인할 수 있습니다. <strong>이 업데이트 이전에 생성된 모든 기존 사용자에게는 자동으로 \"관리자\" 역할이 할당되어, 이전에 수행할 수 있었던 모든 작업을 계속해서 수행할 수 있습니다.</strong></p></section> <section><p>이 업데이트를 통해 보안성과 업무량 분배가 개선되었습니다. 이제 역할은 회사별로 지정되며 회사 구조 간에 상속될 수 없습니다. 사용자를 회사로 초대하거나 이동할 때는 항상 역할을 할당해야 하며, 활성 사용자 할당이 있는 역할은 삭제할 수 없습니다. 이제 <strong>사용자</strong> 페이지에서 <strong>새로운 \"역할\" 필터</strong>를 사용하여 보다 쉽게 관리할 수 있습니다. 조직의 요구에 맞게 접근 권한을 구성하려면 지금 바로 \"역할 및 권한\" 섹션을 살펴보세요.</p></section> <section><p>사용자 및 역할 관리에 대한 자세한 안내는 <a>위키 페이지</a>를 참조하십시오.</p></section>",
                "7": "<section><p>시간에 민감한 작업을 보다 정밀하게 관리할 수 있는 <strong>날짜별 일정 관리</strong> 기능을 통해 작업을 관리하는 강력한 새로운 방법을 선보이게 되어 기쁩니다!</p></section> <section><h3>주요 하이라이트</h3></section> <section><ul><li><strong>특정 마감일</strong> - 새로운 \"날짜별 예약\" 옵션을 사용하여 <strong>특정 날짜 또는 날짜 간격</strong>으로 작업을 예약할 수 있습니다.</li> <li><strong>기본 동작은 동일하게 유지</strong> - 익숙한 <strong>시간별 일정 설정</strong> 기능은 계속해서 완전히 사용할 수 있습니다.</strong></li> <li><strong>사용자 중심의 시간 설정</strong> - 모든 일정은 <strong>사용자의 현지 시간</strong>을 기준으로 생성됩니다. </li></ul></section> <section><h3>작동 방식</h3></section> <section><p>작업에 <strong>\"날짜별 일정\"</strong>을 설정할 때:</p> <ul><li>날짜 선택기 컴포넌트를 통해 <strong>\"시작 날짜\"</strong>와 <strong>\"종료 날짜\"</strong>를 선택합니다.</li> <li>날짜 선택기는 회사 수준의 업무 만료 시간 제한을 따릅니다.</li></ul></section><section><p><strong>날짜별 일정 설정</strong> 기능은 현재 상위 회사 등급에서만 독점적으로 제공되며 <strong>기본</strong> 등급에서는 사용할 수 없습니다.</p></section>",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            },
            "title": {
                "1": "2025년 1월 7일부터 신규 사용자에게 2단계 인증(2FA) 의무화",
                "2": "2025년 6월 3일 예정된 정기 점검",
                "3": "신규 기능 업데이트: 모든 사용자를 위한 간편한 기기 잠금 해제",
                "4": "대시보드에서 새로운 소식을 확인하세요!",
                "5": "중요: 예정된 API 변경 사항 및 역할 및 권한 미리 보기",
                "6": "신규 기능 출시: \"역할 및 권한\"을 통한 강화된 제어 기능",
                "7": "신규 기능: 날짜별 업무 스케줄링으로 더욱 유연한 활용",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            }
        },
        "published": "게시됨",
        "take me there": "바로 가기",
        "tasks": {
            "current": "현재",
            "status": {
                "completed": "완료됨",
                "completed_with_errors": "오류가 포함된 상태로 완료됨",
                "failed": "실패",
                "no tasks": "업무 없음"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7일",
                "tooltipTitle": "지난 7일"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30일",
                "tooltipTitle": "지난 30일"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90일",
                "tooltipTitle": "지난 90일"
            }
        },
        "title": {
            "activated": "활성화된 기기",
            "configurations": "구성",
            "device status": "기기 상태",
            "firmware versions": "펌웨어 버전",
            "imported": "가져온 기기",
            "news": "뉴스",
            "queued tasks": "대기 중인 업무",
            "refreshed every hour": "매시간 새로 고침",
            "resource limits": "리소스 제한",
            "task overview": "업무 개요",
            "tasks": "업무"
        },
        "tooltips": {
            "activated": "선택한 기간(오늘, 지난 7일, 지난 30일, 지난 90일) 동안 FOTA WEB에 처음 연결된 기기 수.",
            "configurations": "장치에 업로드된 구성 파일 이름의 분포를 보여줍니다. 최대 100개의 고유한 파일 이름이 표시됩니다.",
            "firmware versions": "연결된 기기에서 보고된 펌웨어 버전 분포를 표시합니다. 최대 100개의 고유 버전이 표시됩니다.",
            "imported": "선택한 기간(오늘, 지난 7일, 지난 30일, 지난 90일) 동안 계정에 추가된 기기 수."
        }
    },
    "Date picker": {
        "disableFuture": "잘못된 날짜",
        "disablePast": "잘못된 날짜",
        "invalidDate": "잘못된 날짜",
        "maxDate": "잘못된 날짜",
        "minDate": "잘못된 날짜",
        "shouldDisableDate": "잘못된 날짜",
        "shouldDisableMonth": "잘못된 날짜",
        "shouldDisableYear": "잘못된 날짜"
    },
    "Device export": {
        "properties": {
            "activity_status": "",
            "bootloader": "",
            "company_name": "",
            "created_at": "",
            "current_configuration": "",
            "current_firmware": "",
            "description": "",
            "group_name": "",
            "gsm_number": "",
            "iccid": "",
            "imei": "",
            "imsi": "",
            "model": "",
            "model_platform": "",
            "modem_version": "",
            "oem_file_vehicle_name": "",
            "product_code": "",
            "seen_at": "",
            "serial": "",
            "task_queue": "",
            "updated_at": "",
            "vin": ""
        },
        "select data": ""
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "새 장치 추가",
        "add new device description": "선택한 회사 및 그룹에 단일 또는 다수의 새 기기를 추가합니다. FM 또는 FMA와 같은 레거시 기기만 \"레거시 기기로 가져오기\" 체크박스를 선택하여 가져와야 합니다.",
        "add new device legacy title": "레거시 장치로 가져오기.",
        "add new device legacy description": "\"생성일\"을 2016.01.01로 설정하고 \"모델\"을 레거시로 설정하십시오.",
        "add new product code": "신규 제품 코드 추가",
        "add new product code description": "새로운 기기 제품 코드를 추가하고 사용 가능한 CAN 패키지에 연결합니다.",
        "all permissions": "모든 권한",
        "assign access group": "",
        "assign can package description": "패키지 유형을 선택하고 선택한 모든 기기에 할당하세요.",
        "assign role": "역할 할당",
        "attribute value": "속성 값",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "다운로드 시작",
        "by date": "날짜별",
        "by time": "시간별",
        "can adapter": "CAN 어댑터",
        "cancel pending tasks": "동일 업무 유형의 보류 중인 업무 취소",
        "cancel tasks": "업무 취소",
        "cancel tasks in group": {
            "alert title": "이 작업은 완료까지 최대 몇 분이 소요될 수 있습니다.",
            "banner description": "업데이트된 업무 상태를 확인하려면 업무 그룹 세부 정보를 참조하거나 페이지를 새로 고쳐 주십시오.",
            "banner title": "업무 수에 따라 이 작업은 완료까지 최대 몇 분이 소요될 수 있습니다.",
            "description": "\"동의\"를 클릭하면 모든 대기 중인 작업과 실행 중인 작업이 취소됩니다. 계속 진행하시겠습니까?",
            "title": "그룹 내 모든 업무 취소하시겠습니까?"
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "",
        "client email": "고객 담당자 이메일",
        "companies": "기업",
        "company": "회사",
        "company level": {
            "Basic": "기본",
            "Internal": "내부",
            "Premium": "프리미엄",
            "Standard": "표준"
        },
        "company level change description": "회사 등급을 업그레이드하려면 새 등급을 선택하고 그 이유를 설명하십시오. 회사 등급을 다운그레이드하는 것은 불가능합니다. 모든 날짜는 UTC 기준입니다.",
        "company level manual revert": {
            "confirmation": {
                "description": "이 작업은 회사 수준을 자동 할당된 수준 \"{{companyLevel}}\"으로 되돌립니다. 계속하시겠습니까?",
                "title": "수동 레벨 변경을 되돌리시겠습니까?"
            },
            "description": "복원 시 회사 수준이 자동 할당된 수준으로 되돌아가게 됩니다.",
            "title": "이 회사 계정 수준은 {{expirationDate}}까지 수동으로 업그레이드되었습니다."
        },
        "company level type": "기업 수준 유형",
        "company name": "회사명",
        "company statistics": {
            "child companies": "자회사 수",
            "devices": "기기 수",
            "files": "파일 수",
            "groups": "기기 그룹 수",
            "tasks": "업무 수",
            "users": "사용자 수"
        },
        "company type": {
            "All": "",
            "Client": "클라이언트",
            "Internal": "내부",
            "Virtual": "가상"
        },
        "configuration": "구성",
        "confirmations": {
            "are you sure": "정말 확인하시겠습니까?",
            "are you sure you wish to continue": "계속하시겠습니까?",
            "assign can package confirmation": "선택한 패키지를 지정된 수의 기기에 할당하시겠습니까?",
            "cancel task confirmation": {
                "first part": "지정된 수의 작업을 정말 취소하시겠습니까?",
                "second part": "해당하는 작업의 수를 입력하고 \"확인\"을 클릭하십시오."
            },
            "create task confirmation": "지정된 수의 기기에 대해 작업을 생성하시겠습니까?",
            "delete resource confirmation": {
                "first part": "지정된 수의 {{resource}}를 삭제하시겠습니까?",
                "second part": "해당되는 {{resource}}의 수를 입력하고 \"삭제\"를 클릭하세요."
            },
            "delete resources": {
                "companies": "기업",
                "files": "파일",
                "groups": "기기 그룹",
                "deviceModels": "모델",
                "productCodes": "제품 코드",
                "roles": "역할",
                "users": "사용자"
            },
            "description second part": "해당되는 경우, 영향을 받는 기기 수를 입력하고 \"확인\"을 클릭하십시오.",
            "export device data confirmation": "지정된 수의 기기에 대한 기기 데이터를 내보내시겠습니까?",
            "file": "파일에 존재하는 줄 수를 입력하세요",
            "filter": {
                "companies": "필터링된 기업 수 입력",
                "devices": "필터링된 장치 수 입력",
                "files": "필터링된 파일 수 입력",
                "groups": "필터링된 장치 그룹 수 입력",
                "productCodes": "필터링된 제품 코드 수를 입력하세요",
                "tasks": "필터링된 업무 수 입력",
                "users": "필터링된 사용자 수 입력"
            },
            "id_list": {
                "companies": "선택한 기업 수 입력",
                "devices": "선택한 장치의 수를 입력하세요",
                "files": "선택한 파일 수를 입력하세요",
                "groups": "선택한 장치 그룹 수를 입력하세요",
                "productCodes": "선택한 제품 코드 수를 입력하세요",
                "tasks": "선택한 업무 수를 입력하세요",
                "users": "선택한 사용자 수를 입력하세요"
            },
            "merge companies confirmation": "귀사는 {{sourceCompany}}와 {{targetCompany}} 두 회사를 합병할 예정입니다.",
            "move companies confirmation": "{{sourceCompany}}를 {{targetCompany}} 회사로 이전하시려는 중입니다.",
            "move devices confirmation": "지정된 수의 기기를 다른 회사로 이동하시겠습니까?",
            "number of lines": "줄 수",
            "selected 20 or more devices": "20개 이상의 기기를 선택하셨습니다...",
            "transfer devices confirmation": "지정된 수의 기기를 다른 회사로 이전하시겠습니까?"
        },
        "confirm cannot revert": "이 작업은 되돌릴 수 없습니다.",
        "confirm merge companies": "이 회사들을 병합하시겠습니까?",
        "count": "카운트",
        "create company": "회사 생성",
        "create company description": "선택한 모회사 아래에 새 회사를 생성합니다.",
        "create desktop license": "desktop 라이선스 생성",
        "create desktop license description": "고객사의 IP, 하드웨어 키, 만료일(최대 2년)을 포함한 새로운 온라인 FOTA Desktop 라이선스를 발급합니다.",
        "create group": "그룹 생성",
        "create group description": "간편한 관리 및 일괄 할당을 위해 기기를 그룹으로 구성합니다.",
        "create model": "모델 생성",
        "create model description": "이름, 플랫폼 및 TCT web 지원을 지정하여 새 장치 모델 생성.",
        "create offline license": "오프라인 라이선스 생성",
        "create or edit group description": "펌웨어 및 구성을 그룹에 할당할 수 있습니다. 할당 완료 시 모든 그룹 구성원(기기)에 대해 펌웨어 및/또는 구성 업데이트 작업이 생성됩니다.",
        "create role": "역할 생성",
        "create role description": "이름과 설명을 입력하고, 회사를 선택하며, 특정 권한을 할당하여 새 역할을 생성합니다.",
        "create smart group": "스마트 그룹 생성",
        "create smart group banner message": "",
        "create smart group description": "플랫폼별로 그룹에 펌웨어 및 구성 파일을 할당하거나 변경할 수 있습니다. 파일이 할당되거나 변경되면 모든 그룹 장치에 대한 업데이트 업무가 만듭니다.",
        "create task description first step": "구성 또는 펌웨어 업데이트부터 선택 또는 필터링된 장치의 로그, 구성 수신 등에 이르기까지 다양한 작업을 생성할 수 있습니다. 또한 편의를 위해 생성된 작업을 예약할 수 있습니다.",
        "create task description last step": "업무 생성 전에 아래 정보가 정확한지 확인하십시오.",
        "current level": "현재 수준",
        "custom resource limits": {
            "at least one limit must be higher": "최소 한 가지 제한값은 기본 프리미엄 레벨 값보다 높아야 합니다.",
            "configuration files per device": "기기별 구성 파일",
            "confirmation modal description": "{{companyName}} 회사의 다음 리소스 제한을 변경하시겠습니까?",
            "confirmation modal title": "회사 리소스 한도 변경?",
            "count": {
                "companies count": "기업 수: {{number}}",
                "configuration files per device count": "기기당 구성 파일 수: {{number}}",
                "tasks per group count": "그룹별 업무 수: {{number}}",
                "users count": "사용자 수: {{number}}"
            },
            "explanations": {
                "companies": "회사 계층 구조 내에서 생성 가능한 자회사 총 수.",
                "configuration files per device": "저장 가능한 구성 파일 수: 1개의 기기당 1개의 구성 파일이 할당됩니다. 각 기업 수준별로 최소 보장되는 구성 파일 수는 100개입니다.",
                "tasks per group": "하나의 업무 그룹에 포함될 수 있는 업무 수.",
                "users": "회사 계층 구조 내에서 생성 가능한 총 사용자 수."
            },
            "main modal description": "기업, 사용자, 작업 그룹별 작업, 구성 파일 등 다양한 리소스 유형에 대해 사용자 지정 리소스 양을 설정하세요. 사용자 지정 리소스는 프리미엄 레벨 만료 시점 또는 수동 재설정 시까지 활성화됩니다.",
            "resources limit type": "리소스 제한 유형",
            "revert custom resource limits": "사용자 지정 리소스 제한을 복원합니다",
            "revert custom resource limits description": "모든 제한을 재설정하면 리소스 값이 기본값으로 설정되고 회사 수준이 프리미엄으로 변경됩니다.",
            "revert custom resource limits description confirmation": "이 작업은 리소스 제한을 \"프리미엄\" 등급에 자동 할당된 값으로 되돌립니다. 계속하시겠습니까?",
            "revert custom resource limits title": "이 회사의 리소스 제한은 수동으로 설정되었습니다.",
            "revert custom resource limits title confirmation": "사용자 지정 리소스 제한을 복원하시겠습니까?",
            "tasks per group": "그룹별 업무"
        },
        "date range": "날짜 범위",
        "date to": "to",
        "delete companies": "회사 삭제",
        "delete deviceModels": "모델 삭제",
        "delete files": "파일 삭제",
        "delete file warning": "파일 삭제 시 관련 업무 및 업무 그룹이 취소됩니다.",
        "delete groups": "기기 그룹 삭제",
        "delete productCodes": "제품 코드 삭제",
        "delete roles": "역할 삭제",
        "delete tasks and history": "",
        "delete users": "사용자 삭제",
        "description": "설명",
        "desktop license delete description": "\"{{name}}\" Desktop 라이선스를 삭제하시겠습니까?",
        "desktop license name": "Desktop 라이선스 이름",
        "device identifier": "기기 식별자",
        "device transfer": {
            "main": {
                "description": "수신 기업이 생성한 토큰을 사용하여 선택 또는 필터링된 기기를 관련 없는 다른 기업으로 이전합니다.",
                "title": "기기 이체"
            },
            "receive devices": {
                "copy token": "생성된 토큰을 복사하여 해당 기기를 귀사로 이전하는 담당자에게 전달하십시오.",
                "description": "수신 장치 토큰을 생성하여 이체 회사에 전달합니다. ",
                "token info": "이 토큰은 일회용이며 21일 후 만료됩니다."
            },
            "transfer devices": {
                "confirmation": "아래 회사로 장치를 이전하시겠습니까?",
                "device token": "기기 이전 토큰은 기기를 이전하려는 회사의 관리자에게서 반드시 획득해야 합니다.",
                "transfer from file": "회사에서 전송하려는 기기 목록(IMEI)이 포함된 파일을 업로드하세요. 해당 파일은 방금 입력한 토큰을 보유한 회사로 전송됩니다."
            }
        },
        "device transfer token": "기기 이체 토큰",
        "downgrading company level is not possible": "회사 수준의 다운그레이드는 불가능합니다",
        "download sample file message": "필요한 형식의 예시를 보려면 <1>샘플 CSV 템플릿</1>을 다운로드하세요.",
        "edit group banner message": "펌웨어 및/또는 구성 파일을 변경하면 동일한 유형의 모든 이전 대기 중인 작업이 취소됩니다.",
        "edit group description": "이 장치 그룹의 설정을 수정하십시오.",
        "edit role description": "역할의 이름, 설명 및 권한을 사용자 정의할 수 있습니다. 할당된 회사는 변경할 수 없습니다.",
        "edit smart group description": "플랫폼별로 그룹에 펌웨어 및 구성 파일을 할당하거나 변경할 수 있습니다. 파일 할당 또는 변경 시, 해당 그룹의 모든 기기에 대한 업데이트 작업이 생성됩니다.",
        "email": "이메일",
        "enter": "Enter",
        "enter code": "코드 입력",
        "enter description": "설명 입력",
        "enter name": "이름 입력",
        "example": "예:",
        "expires at": "만료일:",
        "explanation": "설명",
        "export device data": "기기 데이터 내보내기",
        "export device description": "",
        "export file format": "내보내기 파일 형식",
        "feature": "기능",
        "feature control": "기능 제어",
        "field disabled until company selected": "회사가 선택될 때까지 이 필드는 비활성화됩니다.",
        "firmware": "펌웨어",
        "files to download": "다운로드할 파일",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "업로드된 1-Wire 인증 목록은 기능의 속도와 정확도를 향상시키기 위해 자동으로 정렬됩니다.",
                "bluetooth_authorization_list": "업로드된 블루투스 인증 목록은 기능의 속도와 정확도를 향상시키기 위해 자동으로 정렬됩니다."
            },
            "endings": {
                "file": "파일",
                "files": "파일"
            },
            "fail": {
                "multiple": "{{failCount}}개의 {{fileEnding}} 파일이 {{totalCount}}개 중 오류로 인해 업로드되지 않았습니다.",
                "single": "{{failCount}}개 중 {{totalCount}}개의 {{fileEnding}} 파일이 오류로 인해 업로드되지 않았습니다."
            },
            "success": {
                "multiple": "선택한 회사들에 모든 파일이 성공적으로 추가되었습니다.",
                "single": "선택한 회사에 모든 파일이 성공적으로 추가되었습니다."
            }
        },
        "filtered": "필터링됨",
        "filtered companies": "필터링된 기업들",
        "filtered devices": "필터링된 장치",
        "filtered files": "필터링된 파일",
        "filtered groups": "필터링된 그룹",
        "filtered tasks": "필터링된 업무",
        "filtered users": "필터링된 사용자",
        "find tool": {
            "device": {
                "error not valid": "IMEI는 반드시 15자리로 구성되어야 합니다",
                "error subtitle": "장치를 찾을 수 없습니다. 다른 IMEI를 입력해 보십시오.",
                "error title": "장치를 찾을 수 없습니다",
                "link": "장치로 이동",
                "no permission": "이 장치를 볼 권한이 없습니다."
            },
            "user": {
                "error not valid": "잘못된 이메일 형식",
                "error subtitle": "사용자를 찾을 수 없습니다. 다른 사용자 이메일을 입력해 보십시오.",
                "error title": "사용자를 찾을 수 없습니다",
                "link": "사용자로 이동",
                "no permission": "이 사용자를 볼 수 있는 권한이 없습니다."
            }
        },
        "firmware date": "펌웨어 날짜",
        "from form": "양식에서",
        "from file": "파일에서",
        "general": "일반",
        "gsm_number": "GSM 번호",
        "iccid": "ICCID",
        "imei": "IMEI",
        "imei restriction": "IMEI 제한",
        "import device data": "기기 데이터 가져오기",
        "import device data description": "제공된 목록의 장치에 대해 선택된 속성 데이터를 가져옵니다.",
        "import device data info": "각 속성에는 괄호 안에 표시된 최대 문자 수 제한이 있습니다. 속성의 문자 수가 최대 제한을 초과할 경우 자동으로 최대 제한까지 줄어듭니다.",
        "import device data limit": "(최대 {{limit}} 자)",
        "imsi": "IMSI",
        "input text too long": "텍스트가 너무 깁니다. 최대 {{maxLength}} 자까지 허용됩니다.",
        "invalid hardware key": "하드웨어 키 형식이 잘못되었습니다",
        "invalid imei": "IMEI가 유효하지 않습니다",
        "invalid ipv4": "잘못된 IPv4 형식",
        "invalid serial": "잘못된 일련 번호",
        "invalid value": "잘못된 값",
        "inverted selection": "역선택",
        "invite user": "사용자 초대",
        "invite user description": "선택한 모회사에 새 사용자를 초대하고 역할을 설정합니다. 초대장 발송 후 사용자는 초대 유효 기간이 만료되기 전까지 30일 이내에 수락해야 합니다.",
        "invite user max roles": "허용되는 최대 역할 수는 5개입니다. 진행하려면 하나를 선택 해제하십시오.",
        "log files": "로그 파일",
        "make": "만들다",
        "manage permissions": "모든 계정 및 사이트 수준의 데이터를 관리합니다.",
        "maximum value is": "최대 값은 {{value}}입니다",
        "merge companies": "회사 합병",
        "merge companies info": "모든 소스 회사 리소스(장치, 그룹, 파일, 회사, 역할을 가진 사용자)는 대상 회사로 이동합니다. 병합하기 전에 사용자 역할을 검토하는 것이 좋습니다. 소스 회사는 나중에 삭제될 것입니다.",
        "merge companies disabled option": {
            "client to internal": "클라이언트 유형 회사는 내부 유형 회사로 병합할 수 없습니다.",
            "internal": "내부 유형 회사는 병합할 수 없습니다.",
            "lz code": "코드 포함 회사는 병합할 수 없습니다."
        },
        "minimum value is": "최소값은 {{value}}입니다",
        "move companies disabled option": {
            "internal": "내부 유형 회사는 이동할 수 없습니다."
        },
        "move device": "기기 이동",
        "move device description": "선택 또는 필터링된 기기를 회사 계층 구조 내 기존 회사 및/또는 그룹으로 이동합니다.",
        "move device group": "",
        "move device group banner": "",
        "move device group description": "",
        "move devices": "기기 이동",
        "name": "이름",
        "newest": "최신 버전부터",
        "no dropdown files": {
            "description": "이 옵션을 선택하려면 새 $t(Dialog##no dropdown files##file names##{{fileName}}) 파일을 업로드하십시오.",
            "description no permission create file": "",
            "file names": {
                "1_wire_authorization_list": "1-Wire 인증 목록",
                "adas_firmware": "ADAS 펌웨어",
                "ble_fw": "BLE 펌웨어",
                "blue_nrg": "BlueNrg 펌웨어",
                "bluetooth_authorization_list": "블루투스 인증 목록",
                "can_chip_firmware": "FM CAN 칩 펌웨어",
                "carrier_advance_firmware": "Carrier Advance 펌웨어",
                "carrier_advance_settings": "Carrier Advance 설정",
                "carrier_apx_firmware": "Carrier APX 펌웨어",
                "carrier_apx_settings": "Carrier APX 설정",
                "certificate": "TLS 인증서",
                "configuration": "구성",
                "dsm_firmware": "DSM 펌웨어",
                "dtb": "DTB",
                "firmware": "펌웨어",
                "fw_bundle": "펌웨어 번들",
                "gnssm_download_assistant": "GNSS-M 다운로드 어시스턴트",
                "gnssm_firmware": "GNSS-M 펌웨어",
                "main configuration": "",
                "manual_geofence_list": "수동 지오펜스 시나리오 목록",
                "meig_modem_firmware": "MeiG 모뎀 펌웨어",
                "netprisma_modem_firmware": "NETPRISMA 모뎀 펌웨어",
                "psub": "구독",
                "quectel_modem_firmware": "퀘이텔 모뎀 펌웨어",
                "simcom_modem_firmware": ""
            },
            "main": "$t(Dialog##no dropdown files##file names##{{fileName}}) 파일이 없습니다."
        },
        "none": "없음",
        "obd oem": "OBD OEM",
        "offline license delete description": "오프라인 라이선스 \"{{name}}\"을 삭제하시겠습니까?",
        "oldest": "가장 오래된 것부터",
        "only integers": "정수 값만 유효합니다",
        "only numbers": "숫자만 유효합니다",
        "optional": "선택 사항",
        "other companies": "다른 기업들",
        "parent company": "모회사",
        "permission preset": "권한 사전 설정",
        "platform compatibility": {
            "banner text": "선택한 일부 기기 모델은 선택한 업무 유형과 호환되지 않습니다. 호환되지 않는 기기 모델의 경우 해당 업무 유형이 기본적으로 생성되지 않습니다.",
            "compatible model devices": "호환 가능한 모델 기기",
            "count text": "{{totalCount}}개의 장치 중 <1>{{compatibleCount}}</1>개에 대해 작업이 생성됩니다.",
            "create tasks for incompatible devices": "호환되지 않는 기기를 위한 업무 생성.",
            "devices from file": "파일의 장치",
            "platform": "{{title}} 플랫폼",
            "task applies": "업무 적용 대상",
            "task cannot be created": "호환되지 않는 모델의 장치에 대해서는 작업을 생성할 수 없습니다."
        },
        "receiving company": "이 회사는 귀하의 기기를 수령할 것입니다",
        "resend user invitation": "",
        "retry tasks in group": {
            "alert title": "이 작업은 완료까지 최대 몇 분이 소요될 수 있습니다.",
            "banner description": "업데이트된 업무 상태를 확인하려면 업무 그룹 세부 정보를 참조하거나 페이지를 새로 고쳐 주십시오.",
            "description": "\"수락\"을 누르면 모든 실패한 작업을 재시도합니다. 계속 진행하시겠습니까?",
            "title": "그룹 내 모든 작업을 재시도하시겠습니까?"
        },
        "revision": "개정판",
        "revision value error": "값은 두 자리 숫자여야 합니다(00 - 99).",
        "role name": "역할 이름",
        "root company": "모회사",
        "sales email": "영업 관리자 이메일",
        "scheduled time warning": "예약된 시간의 작업은 기기의 FOTA 연결 시간 설정을 변경하지 않습니다. 기기가 선택한 시간대 내에 FOTA에 연결되면 작업이 실행됩니다. 기기가 선택한 시간대보다 짧지 않은 주기로 FOTA WEB에 연결되도록 설정되었는지 확인하십시오.",
        "schedule task": "스케줄 업무",
        "select": "선택",
        "select at least one": {
            "companies": "최소 한 개의 회사를 선택해 주세요",
            "devices": "최소 한 개의 기기를 선택해 주세요",
            "files": "최소 한 개의 파일을 선택해 주세요",
            "groups": "최소 한 개의 그룹을 선택하십시오",
            "tasks": "최소 한 가지 작업을 선택해 주세요",
            "users": "최소 한 명의 사용자를 선택하십시오"
        },
        "selected": "선정됨",
        "selected companies": "선정된 기업들",
        "selected deviceModels": "선정된 모델",
        "selected devices": "선택된 장치",
        "selected files": "선택된 파일",
        "selected groups": "선택된 장치 그룹",
        "selected productCodes": "선택된 제품 코드",
        "selected roles": "선택된 역할",
        "selected tasks": "선택된 업무",
        "selected users": "선택된 사용자",
        "select company": "",
        "select group": "",
        "select time interval": "시간 간격 선택",
        "selected time window": "선택한 시간 범위: {{fromDate}}부터 {{toDate}}까지",
        "set bluetooth password": {
            "bluetooth password": "",
            "repeat bluetooth password": "",
            "enter password": "",
            "password source": "",
            "rules": {
                "allowed characters": "",
                "characters length": "",
                "passwords must match": ""
            },
            "SystemGenerated": {
                "description": ""
            },
            "UserEntered": {
                "description": ""
            }
        },
        "show files for selected companies only": "",
        "smart group": {
            "description": "{{platformName}} 플랫폼 기기에서 사용 가능한 파일을 선택하십시오.",
            "title": "{{platformName}} 플랫폼 파일"
        },
        "sn": "일련 번호",
        "specific": "특정",
        "time period": "기간",
        "time period custom": "맞춤형",
        "tls certificate transfer info": "",
        "token has expired": "토큰이 만료되었습니다",
        "token is valid": "토큰은 유효합니다",
        "transfer companies": "이체 회사",
        "transfer companies description": "두 회사를 이동할지 병합할지 선택하세요. 일부 옵션은 되돌릴 수 없습니다.",
        "transfer devices": "이체 장치",
        "tri source": {
            "selected tab description": {
                "create task": "선택된 작업은 체크박스를 사용하여 선택된 기기에 대해 생성됩니다.",
                "general": "선택된 작업은 체크박스를 통해 선택된 기기에 대해 실행됩니다."
            },
            "filtered tab description": {
                "create task": "선택된 작업은 하나 이상의 사용 가능한 필터를 사용하여 필터링된 기기에 대해 생성됩니다.",
                "general": "선택된 작업은 하나 이상의 사용 가능한 필터를 사용하여 필터링된 장치에 대해 실행됩니다."
            },
            "from file tab description": {
                "create task": "선택된 작업은 업로드된 파일에 명시된 기기들을 대상으로 생성됩니다.",
                "general": "선택된 작업은 업로드된 파일에 명시된 기기들에 대해 실행됩니다."
            }
        },
        "unlocker": {
            "generate unlock key": "잠금 해제 키 생성",
            "generate unlock key description": "아래 필드에 TCT에서 제공된 기기 \"잠금 코드\"를 입력하세요. \"생성\" 버튼을 눌러 잠금 해제 키를 생성한 후, TCT에서 해당 키를 사용하여 기기의 잠금을 해제하세요.",
            "invalid lock code": "무효한 장치 잠금 코드입니다.",
            "limit reached": "생성된 잠금 해제 키의 최대 개수에 도달했습니다.",
            "lock code": "잠금 코드",
            "unlock key": "잠금 해제 키",
            "unlock key success message": "잠금 해제 키가 성공적으로 생성되었습니다."
        },
        "upload file": "파일 업로드",
        "upload file description": "드래그 앤 드롭 필드 또는 선택을 통해 한 번에 최대 {{count}}개의 파일을 업로드할 수 있습니다.",
        "upload firmware bundle container info": "",
        "upload firmware downgrade protection info": "04.00.00 이상 펌웨어 버전에는 다운그레이드 보호 기능이 포함됩니다. 펌웨어 변경 사항에 대한 자세한 내용은 <1>Teltonika GPS Wiki</1> 문서를 참조하십시오. \"다음\" 버튼을 누름으로써 귀하는 위 정보를 동의하고 이해한 것으로 간주됩니다.",
        "upload firmware unsupported info": "본 버전으로의 업데이트는 불가능합니다. Teltonika 지원팀 또는 담당 영업 매니저에게 문의하십시오.",
        "use at least one filter": "필터 중 하나 이상을 사용해 주세요",
        "user": "사용자",
        "valid until": "유효 기간:",
        "valid until date disable description": "이 필드는 기간 설정이 \"사용자 지정\"으로 설정된 경우에만 변경할 수 있습니다",
        "vehicle model": "모델"
    },
    "Dropzone": {
        "add file": "파일 추가",
        "add files": "파일 추가",
        "drop file to upload": "업로드할 파일을 드래그 앤 드롭하세요",
        "drop files to upload": "파일을 드래그하여 업로드하세요",
        "error uploading the file": "파일 업로드 중 오류가 발생했습니다",
        "file invalid type": "잘못된 파일 형식이 선택되었습니다.",
        "file successfully uploaded": "파일이 성공적으로 업로드되었습니다",
        "file syntax": "파일 구문은 다음과 같습니다:",
        "invalid format or size": "",
        "max file size": "",
        "maximum file limit reached": "최대 파일 제한에 도달했습니다.",
        "only one file can be attached": "한 번에 하나의 파일만 첨부할 수 있습니다.",
        "or drop file to upload": "또는 파일을 드래그하여 업로드",
        "or drop files to upload": "또는 파일을 드래그하여 업로드",
        "rows detected": "파일 내 행 성공적으로 감지됨",
        "select file": "파일 선택",
        "select files": "파일 선택",
        "select file type": "먼저 파일 유형을 선택해 주세요.",
        "supported formats": "지원되는 형식",
        "too long file name": "파일 이름이 너무 깁니다. 최대 {{maxLength}} 자까지 허용됩니다.",
        "too many files description": "선택한 파일을 업로드한 후 나머지 파일들을 업로드할 수 있습니다.",
        "too many files title": "한 번에 첨부할 수 있는 파일의 최대 개수는 {{maxFiles}}개입니다."
    },
    "Error": {
        "error": "오류",
        "message wait": "오류가 수정될 때까지 잠시만 기다려 주십시오.",
        "title": "문제가 발생했습니다!"
    },
    "Feature highlight": {
        "got it": "알겠습니다",
        "new feature": "신규 기능!",
        "scenarios description": "이제 기기에서 다음 시나리오 중 하나를 설정할 수 있습니다: 과속 감지, 충돌 감지 또는 견인 감지."
    },
    "Filter": {
        "access group": "",
        "activity_status": "상태",
        "all permissions": "모든 권한",
        "batch_id": "배치 ID",
        "company_id": "회사",
        "company selector": "",
        "configuration change origin": "",
        "configuration_file_id": "",
        "configuration type": "",
        "created_by": "제작:",
        "current_configuration": "구성",
        "current_firmware": "펌웨어",
        "device_imei": "기기 IMEI",
        "file type": "파일 유형",
        "filtered by": "필터링됨",
        "filters used": "사용된 필터",
        "firmware_file_id": "",
        "ft_bluetooth_auth_list_file_id": "",
        "ft_configuration_file_id": "",
        "ft_firmware_file_id": "",
        "ft_one_wire_auth_list_file_id": "",
        "group_id": "그룹",
        "id": "ID",
        "Invalid company": "잘못된 회사",
        "model": "모델",
        "model_platform": "플랫폼",
        "Multiple companies": "여러 기업",
        "parent company": "모회사",
        "permission": "권한",
        "permission status": "상태",
        "role": "역할",
        "spec_id": "Spec ID",
        "status_id": "상태",
        "supported_task_type": "업무 유형",
        "table filters": "테이블 필터",
        "task type": "업무 유형",
        "task_queue": "큐",
        "type": "유형",
        "user status": "상태"
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "ADAS 펌웨어 파일 크기는 0이 될 수 없습니다.",
        "ADAS firmware is invalid.": "ADAS 펌웨어가 유효하지 않습니다.",
        "All notifications were deleted.": "모든 알림이 삭제되었습니다.",
        "All notifications were marked as read.": "모든 알림이 읽음으로 표시되었습니다.",
        "At least one user role must be provided.": "최소 하나의 사용자 역할이 제공되어야 합니다.",
        "Attributes length is invalid": "속성 길이가 잘못되었습니다.",
        "Banner was updated.": "",
        "Batch was discarded": "배치는 폐기되었습니다.",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "대량 속성 업데이트 작업이 생성되었습니다. 기기 속성이 곧 업데이트될 예정입니다.",
        "Bulk create job was created. Devices will be created shortly.": "대량 생성 작업이 생성되었습니다. 기기가 곧 생성될 예정입니다.",
        "Bulk create job was created. Tasks will be created shortly.": "대량 업무 생성 작업이 생성되었습니다. 작업이 곧 생성될 예정입니다.",
        "Bulk delete job was created. Companies will be removed shortly.": "대량 삭제 작업이 생성되었습니다. 곧 기업들이 제거될 예정입니다.",
        "Bulk delete job was created. Devices will be removed shortly.": "대량 삭제 작업이 생성되었습니다. 기기들이 곧 제거될 예정입니다.",
        "Bulk delete job was created. Files will be removed shortly.": "대량 삭제 작업이 생성되었습니다. 파일이 곧 제거될 예정입니다.",
        "Bulk delete job was created. Groups will be removed shortly.": "대량 삭제 작업이 생성되었습니다. 그룹은 곧 제거될 예정입니다.",
        "Bulk delete job was created. Product codes will be removed shortly.": "일괄 삭제 작업이 생성되었습니다. 제품 코드는 곧 제거될 예정입니다.",
        "Bulk delete job was created. Users will be removed shortly.": "대량 삭제 작업이 생성되었습니다. 사용자는 곧 제거될 예정입니다.",
        "Bulk task create job was created. Tasks will be created shortly.": "대량 작업이 생성되었으며 곧 작업이 표시될 예정입니다. 작업은 \"업무 그룹\" 페이지의 업무 그룹 세부 정보에서 확인할 수 있습니다.",
        "Bulk update job was created. Devices will be updated shortly.": "대량 업데이트 작업이 생성되었습니다. 기기들은 곧 업데이트될 예정입니다.",
        "Bulk update job was created. Tasks will be updated shortly.": "대량 업데이트 작업이 생성되었습니다. 작업은 곧 업데이트될 예정입니다.",
        "Can adapter was added.": "Can 어댑터가 추가되었습니다.",
        "Can adapter was deleted.": "Can 어댑터가 삭제되었습니다.",
        "Can adapter was updated.": "Can 어댑터가 업데이트되었습니다.",
        "Can chip firmware file size can't be zero": "칩 펌웨어 파일 크기는 0이 될 수 없습니다.",
        "Can chip firmware is invalid.": "칩 펌웨어가 유효하지 않을 수 있습니다.",
        "Cannot delete company. Company is not empty.": "회사를 삭제할 수 없습니다. 회사가 비어 있지 않습니다.",
        "Cannot delete file. It is used by pending or running tasks.": "파일을 삭제할 수 없습니다. 해당 파일은 보류 중이거나 실행 중인 작업에 사용됩니다.",
        "Cannot delete file. It is used by running tasks.": "파일을 삭제할 수 없습니다. 실행 중인 작업에서 사용 중입니다.",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "장치에 할당된 제품 코드는 삭제할 수 없습니다.",
        "check your email for details": "",
        "Companies count limit exceeded.": "기업 계정 한도 초과.",
        "Companies in the request must belong to the selected root.": "요청 대상 기업은 선택된 루트에 속해야 합니다.",
        "Company merge job was created. It will be merged shortly.": "회사 병합 작업이 생성되었습니다. 곧 병합될 예정입니다.",
        "Company name already exist.": "회사명은 이미 존재합니다.",
        "Company level change is not allowed.": "회사 수준의 변경은 허용되지 않습니다.",
        "Company level successfully changed": "회사 수준 변경이 성공적으로 완료되었습니다.",
        "company level successfully reverted": "회사 수준이 자동 할당 수준으로 성공적으로 복원되었습니다.",
        "Company not allowed to be merged": "회사는 합병이 허용되지 않습니다.",
        "company resource limits changed": "회사 리소스 한도 변경이 성공적으로 완료되었습니다.",
        "Company was created.": "회사가 설립되었습니다.",
        "Company was deleted.": "회사가 삭제되었습니다.",
        "Company was updated.": "회사가 업데이트되었습니다.",
        "compatibilities added": "동기화 과정에서 {{count}}개의 새로운 호환성이 추가되었습니다.",
        "compatibilities synchronized": "누락된 호환성을 성공적으로 동기화했습니다.",
        "Configuration cannot have FOTA functionality disabled": "구성에서 FOTA 기능을 비활성화할 수 없습니다.",
        "Configuration file cannot contain duplicate parameters": "구성 파일에는 중복 매개변수를 포함할 수 없습니다.",
        "Configuration file size can't be zero": "구성 파일 크기는 0일 수 없습니다.",
        "Configuration files count limit exceeded.": "구성 파일 수 제한 초과.",
        "Configuration version must be defined": "구성 버전을 반드시 정의해야 합니다.",
        "custom resource limits successfully reverted": "사용자 지정 리소스 제한이 자동 할당된 제한으로 성공적으로 복원되었습니다.",
        "Custom roles feature is not enabled.": "사용자 지정 역할 기능은 프리미엄 회사 등급을 가진 사용자만 사용할 수 있습니다. 이전에 생성된 사용자 지정 역할은 삭제할 수 있습니다.",
        "desktop license added": "Desktop 라이선스 \"{{name}}\"이(가) 성공적으로 추가되었습니다.",
        "Devices already are in target company": "해당 기기들은 이미 대상 기업에 설치되어 있습니다.",
        "Device already exists.": "장치는 이미 존재합니다.",
        "Device bulk attribute update file cannot be empty": "장치 대량 속성 업데이트 파일은 비어 있을 수 없습니다.",
        "Device bulk attribute update file should be .csv": "장치 대량 속성 업데이트 파일은 .csv 형식이어야 합니다.",
        "Device export limit reached. You can not export more than 100000 devices": "기기 내보내기 한도에 도달했습니다. 100,000개 이상의 기기를 내보낼 수 없습니다.",
        "Device import limit reached. You can not import more than 100 devices": "기기 가져오기 한도에 도달했습니다. 100개 이상의 기기를 가져올 수 없습니다.",
        "Device model and task type compatibility was updated.": "기기 모델 및 업무 유형 호환성이 업데이트되었습니다.",
        "Device model was created.": "기기 모델이 생성되었습니다.",
        "Device model was deleted.": "기기 모델이 삭제되었습니다.",
        "Device model was updated.": "기기 모델이 업데이트되었습니다.",
        "Device not found": "장치를 찾을 수 없습니다.",
        "Device Transfer job was created. Devices will be transfered shortly.": "기기 이체 작업이 생성되었습니다. 기기들이 곧 전송될 예정입니다.",
        "Device was added.": "장치가 추가되었습니다.",
        "Device was deleted.": "장치가 삭제되었습니다.",
        "Device was updated.": "장치가 업데이트되었습니다.",
        "Email or password is incorrect.": "입력하신 이메일 또는 비밀번호가 잘못되었습니다.",
        "Failed to create Product code": "제품 코드 생성에 실패했습니다.",
        "Failed to delete Product code": "제품 코드 삭제에 실패했습니다.",
        "Failed to import devices.": "장치 가져오기에 실패했습니다.",
        "Failed to Read Product code": "제품 코드 읽기에 실패했습니다.",
        "Failed to retry failed tasks": "실패한 업무 재시도에 실패했습니다.",
        "Failed to update Product code": "제품 코드 업데이트에 실패했습니다.",
        "Failed to update task for retry": "실패한 업무 재시도에 실패했습니다.",
        "Field is not valid": "필드가 유효하지 않습니다.",
        "File description is too long. Max 255 characters allowed.": "파일 설명이 너무 깁니다. 최대 255자까지 허용됩니다.",
        "File exceeds entries limit of 10000.": "파일 크기가 10,000바이트의 입력 제한을 초과합니다.",
        "File must not contain duplicated IMEIs": "파일에는 중복된 IMEI가 포함되어서는 안 됩니다.",
        "File must not contain IMEIs that already exist in database.": "파일에는 데이터베이스에 이미 존재하는 IMEI가 포함되어서는 안 됩니다.",
        "File must not contain invalid IMEIs": "파일에는 유효하지 않은 IMEI가 포함되어서는 안 됩니다.",
        "File name is too long. Max 255 characters allowed.": "파일 이름이 너무 깁니다. 최대 255자까지 허용됩니다.",
        "File name should not contain illegal characters or symbols": "파일 이름에는 특수 문자를 포함할 수 없습니다.",
        "File not found": "파일을 찾을 수 없습니다.",
        "File was deleted.": "파일이 삭제되었습니다.",
        "File was successfully uploaded.": "파일이 성공적으로 업로드되었습니다.",
        "File was updated.": "파일이 업데이트되었습니다.",
        "File was uploaded. Devices will be imported shortly.": "파일이 업로드되었습니다. 기기들은 곧 가져올 예정입니다.",
        "File will be created shortly. Check files in a second.": "파일이 곧 생성됩니다. 잠시 후 파일을 확인하세요.",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "펌웨어 파일 크기는 0이 될 수 없습니다.",
        "First device in file not found.": "파일 내 첫 번째 장치를 찾을 수 없습니다.",
        "Forbidden": "금지됨.",
        "Group name already exist.": "그룹 이름이 이미 존재합니다.",
        "Group was added.": "\"'{{group}}'\"이(가) 성공적으로 생성되었습니다.",
        "Group was created.": "그룹이 생성되었습니다.",
        "Group was deleted.": "그룹이 삭제되었습니다.",
        "Group was updated.": "그룹이 업데이트되었습니다.",
        "Invalid device bulk update attribute": "무효한 장치 대량 업데이트 속성.",
        "Invalid email address.": "잘못된 이메일 주소입니다.",
        "Invalid file contents": "파일 내용이 잘못되었습니다.",
        "Invalid file name": "잘못된 파일 이름입니다.",
        "Invalid invitation token.": "초대 토큰이 잘못되었습니다.",
        "Invalid token": "잘못된 토큰입니다.",
        "Invalid token length": "토큰 길이 오류.",
        "Internal Server Error": "내부 서버 오류.",
        "Internal users must sign in using Microsoft Entra ID.": "",
        "License was deleted.": "라이선스가 삭제되었습니다.",
        "License was updated.": "라이선스가 업데이트되었습니다.",
        "Maximum companies hierarchy depth exceeded": "최대 기업 계층 구조 깊이 초과",
        "Maximum device group size exceeded.": "최대 장치 그룹 크기를 초과했습니다.",
        "Method Not Allowed": "메서드 허용되지 않음.",
        "Network Error": "네트워크 오류.",
        "No changes made": "변경 사항은 없습니다.",
        "No resources found.": "자원을 찾을 수 없습니다.",
        "not allowed to affect batch": {
            "description": "이 업무 그룹을 생성한 사용자의 회사를 관리하고 있는지 반드시 확인하십시오.",
            "title": {
                "approve": "이 배치 작업을 승인할 권한이 없습니다.",
                "discard": "이 배치 작업을 취소할 권한이 없습니다."
            }
        },
        "Not Found": "찾을 수 없습니다.",
        "Notification was deleted.": "알림이 삭제되었습니다.",
        "notify when done title": "이 작업에는 시간이 다소 소요될 수 있습니다. 아래 버튼을 눌러 이 화면을 닫으시면 완료 시 알림을 받으실 수 있습니다.",
        "Obd record was created.": "OBD 기록이 생성되었습니다.",
        "Obd record was updated.": "OBD 기록이 업데이트되었습니다.",
        "offline license added": "오프라인 라이선스 \"{{name}}\"이(가) 성공적으로 추가되었습니다.",
        "Offline license was deleted.": "오프라인 라이선스가 삭제되었습니다.",
        "Only id_list source is supported.": "id_list 소스만 지원됩니다.",
        "Only users with Teltonika email can be invited into internal companies.": "Teltonika 이메일 계정을 보유한 사용자만 내부 회사에 초대할 수 있습니다.",
        "Only users with Teltonika email can be moved into internal companies.": "Teltonika 이메일 계정을 보유한 사용자만 내부 회사로 이동할 수 있습니다.",
        "Parent company cannot be a descendant of the updated company.": "모회사는 업데이트된 회사의 하위 회사가 될 수 없습니다.",
        "Password reset link was sent to Your email.": "비밀번호 재설정 링크가 귀하의 이메일로 발송되었습니다.",
        "Password reset token is invalid, expired or related user no longer exists.": "비밀번호 재설정 토큰이 유효하지 않거나 만료되었거나 해당 사용자가 더 이상 존재하지 않습니다.",
        "Password was changed.": "비밀번호가 변경되었습니다.",
        "product code added": "제품 코드 \"{{code}}\"가 성공적으로 추가되었습니다.",
        "Product code is too long. Max 200 characters allowed.": "제품 코드가 너무 깁니다. 최대 200자까지 허용됩니다.",
        "ProductCode already exists.": "제품 코드는 이미 존재합니다.",
        "ProductCode not found": "제품 코드를 찾을 수 없습니다.",
        "Product code was deleted.": "제품 코드가 삭제되었습니다.",
        "Product code was updated.": "제품 코드가 업데이트되었습니다.",
        "Retry failed tasks job was created": "실패한 업무 재시도 작업이 생성되었습니다.",
        "Role cannot be set for an internal user.": "내부 사용자에게는 역할을 설정할 수 없습니다.",
        "Role was created.": "역할이 생성되었습니다.",
        "Role was deleted.": "역할이 삭제되었습니다.",
        "Role was updated.": "역할이 업데이트되었습니다.",
        "selected company changed": "선택된 회사가 변경되었습니다.",
        "Selected firmware bundle is not supported by the device.": "선택한 펌웨어 번들은 해당 기기에서 지원되지 않습니다.",
        "Server Error": "서버 오류.",
        "signalr connection failed": "",
        "signalr join groups failed": "",
        "SMS was sent.": "SMS가 발송되었습니다.",
        "Something went wrong while saving a new password.": "새 비밀번호 저장 중 문제가 발생했습니다.",
        "Successfully logged out.": "로그아웃에 성공했습니다.",
        "System Admin user level is required in order to perform this action.": "이 작업을 수행하려면 시스템 관리자 사용자 권한이 필요합니다.",
        "Target company cannot be a descendant of source company.": "대상 회사는 소스 회사의 하위 회사가 될 수 없습니다.",
        "Task create limit exceeded.": "100,000개 이상의 기기를 위한 업무 그룹을 생성할 수 없습니다.",
        "Task type is not retriable": "업무 유형은 재시도할 수 없습니다",
        "Task was added.": "작업이 추가되었습니다.",
        "task was created": "{{imei}}(\"{{taskType}}\")에 대한 작업이 생성되었습니다. 해당 작업은 장치 상세 정보의 \"업무\" 항목 아래 \"장치\" 페이지에서 확인할 수 있습니다.",
        "Task was updated.": "작업이 업데이트되었습니다.",
        "Tasks were approved": "작업이 승인되었습니다.",
        "The given data was invalid.": "제공된 데이터가 유효하지 않습니다.",
        "time zone changed": "시간대가 변경되었습니다.",
        "Token cannot be null or empty": "토큰은 null이거나 비어 있을 수 없습니다.",
        "token created": "API 토큰이 성공적으로 생성되었습니다.",
        "Token has expired": "토큰이 만료되었습니다.",
        "Token's and token's owner companies do not match": "토큰과 토큰 소유 기업이 일치하지 않습니다.",
        "Token was deleted.": "토큰이 삭제되었습니다.",
        "Too many resources in the request": "요청에 포함된 리소스가 너무 많습니다",
        "Too Many Requests": "요청이 너무 많습니다.",
        "Transfer token created": "이체 토큰 생성됨.",
        "tutorial completed": "",
        "Two factor authentication is already activated for the user.": "사용자에 대한 2단계 인증은 이미 활성화되어 있습니다.",
        "Two factor authentication successfully disabled.": "2단계 인증이 성공적으로 비활성화되었습니다.",
        "Unable to send SMS. This device does not have a GSM number assigned.": "SMS 발송 불가. 이 장치에는 GSM 번호가 할당되지 않았습니다.",
        "Unable to validate Your request.": "요청을 확인할 수 없습니다.",
        "Unauthenticated.": "인증되지 않음.",
        "Unauthorized": "무단 접근 금지.",
        "User access level is not valid": "사용자 접근 수준이 유효하지 않습니다",
        "User invitation was revoked": "초대장이 성공적으로 취소되었습니다.",
        "User invitation was re-sent": "사용자 초대장이 재발송되었습니다.",
        "User is already in the system.": "사용자는 이미 시스템에 로그인된 상태입니다.",
        "User was created.": "사용자가 생성되었습니다.",
        "User was deleted.": "사용자가 삭제되었습니다.",
        "User was invited.": "사용자 초대 성공적으로 발송되었습니다.",
        "User was updated": "사용자가 업데이트되었습니다.",
        "Users count limit exceeded.": "사용자 수 제한 초과.",
        "Your password has been changed.": "귀하의 비밀번호가 변경되었습니다."
    },
    "General": {
        "0": "사용자",
        "5": "지원",
        "10": "관리자",
        "15": "관리자 관리자",
        "19": "",
        "20": "시스템 사용자",
        "99": "슈퍼 유저",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "회사 생성",
        "Company.Delete": "회사 삭제",
        "Company.Merge": "회사 합병",
        "Company.Update": "회사 업데이트",
        "Device.Export": "기기 내보내기",
        "Device.Read": "기기 읽기",
        "Device.SecretsRead": "",
        "Device.Transfer": "기기 이체",
        "Device.Unlock": "기기 잠금 해제",
        "Device.Update": "기기 업데이트",
        "DeviceGroup.Create": "기기 그룹 생성",
        "DeviceGroup.Delete": "기기 그룹 삭제",
        "DeviceGroup.Read": "기기 그룹 읽기",
        "DeviceGroup.Update": "기기 그룹 업데이트",
        "File.Create": "파일 생성",
        "File.Delete": "파일 삭제",
        "File.Download": "파일 다운로드",
        "File.Read": "파일 읽기",
        "File.TctWebAccess": "TCT web",
        "File.Update": "파일 업데이트",
        "Role.Create": "역할 생성",
        "Role.Delete": "역할 삭제",
        "Role.Read": "역할 읽기",
        "Role.Update": "역할 업데이트",
        "Task.Create": "업무 생성",
        "Task.Read": "업무 읽기",
        "Task.Retry": "업무 재시도",
        "Task.Update": "업무 업데이트",
        "TaskGroup.Read": "업무 그룹 읽기",
        "TctIntegration.Access": "TCT 통합",
        "Token.Create": "토큰 생성",
        "Token.Delete": "토큰 삭제",
        "Token.Read": "토큰 읽기",
        "User.Create": "",
        "User.Delete": "사용자 삭제",
        "User.Read": "사용자 읽기",
        "User.Update": "사용자 업데이트",
        "--- END-OF-PERMISSIONS ---": "",
        "1_wire_authorization": "",
        "1-wire authorization list": "1-Wire 인증 목록",
        "1_wire_authorization_list": "1-Wire 인증 목록",
        "Active": "활성",
        "adas_firmware": "ADAS 펌웨어",
        "apx_firmware": "APX 펌웨어",
        "assign can package": "CAN 패키지 할당",
        "assigned package": "할당된 패키지",
        "automatic": "자동화",
        "banner management": "",
        "batches": "업무 그룹",
        "black_box": "블랙박스",
        "ble_dtb": "BLE DTB",
        "ble_fw": "BLE 펌웨어",
        "blue_nrg": "BlueNRG 펌웨어",
        "bluetooth_authorization": "",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "블루투스 인증 목록",
        "bluetooth_authorization_list": "블루투스 인증 목록",
        "bluetooth password": "",
        "boolean filtered value name": {
            "task_support": {
                "false": "호환되지 않음",
                "true": "호환 가능"
            },
            "web_editor_support": {
                "false": "TCT web 미지원",
                "true": "TCT web 지원"
            }
        },
        "can": "CAN",
        "can adapter name": "CAN 어댑터 이름",
        "can bootstring": "부트스트링",
        "can configuration": "OEM 구성",
        "can_debug_log": "CAN 디버그 로그",
        "can oem file package": "OEM 파일 패키지",
        "can oem file vehicle": "OEM 파일 차량",
        "can package": "OEM 패키지",
        "can program number": "CAN 프로그램 번호",
        "can revision": "CAN 개정판",
        "can software date": "CAN 소프트웨어 데이터",
        "can type": "CAN 타입",
        "Cancelled": "취소됨",
        "cancel task": "업무 취소",
        "can_chip_firmware": "FM CAN 칩 펌웨어",
        "carrier_advance_firmware": "Carrier Advance 펌웨어",
        "carrier_advance_settings": "Carrier Advance 설정",
        "carrier_apx_firmware": "Carrier APX 펌웨어",
        "carrier_apx_settings": "Carrier APX 설정",
        "carrier_extractions": "Carrier extractions",
        "carrier_logger_files": "Carrier 온도 로거 파일",
        "certificate": "인증서",
        "click for more details": "자세한 내용은 클릭하세요",
        "client ip": "클라이언트 IP",
        "clone model": "기기 모델 복제",
        "collapse menu": "메뉴 축소",
        "companies": "기업",
        "company": "회사",
        "company level": "기업 수준",
        "company type": "회사 유형",
        "company name": "회사명",
        "Completed": "완료됨",
        "Completed with errors": "오류가 포함된 상태로 완료됨",
        "configuration": "구성",
        "configuration_36": "구성 (FM36)",
        "configuration_64": "구성 (FMB64)",
        "crash_dump": "충돌 덤프 로그",
        "created at": "창조 시간",
        "created by": "창조자",
        "custom": "맞춤형",
        "custom resource limits": "사용자 지정 리소스 제한",
        "dashboard": "대시보드",
        "delete desktop license": "Desktop 라이선스 삭제",
        "delete offline license": "오프라인 라이선스 삭제",
        "desktopLicenses": "Desktop 라이선스",
        "device_export_file_csv": "기기 내보내기 파일 (.csv)",
        "device_export_file_xlsx": "기기 내보내기 파일 (.xlsx)",
        "deviceModels": "모델",
        "deviceModelTaskCompatibilities": "호환성",
        "device_transfer_report": "기기 이전 보고서",
        "device group": "그룹",
        "DeviceImportFile": "기기 가져오기 파일",
        "devices": "기기",
        "download file": "파일 다운로드",
        "download offline license": "오프라인 라이선스 다운로드",
        "dsm_firmware": "DSM 펌웨어",
        "dtb": "DTB",
        "edit compatibility": "기기 호환성 편집",
        "edit model": "기기 모델 편집",
        "edit company": "회사 정보 수정",
        "edit desktop license": "Desktop 라이선스 편집",
        "edit device": "기기 편집",
        "edit file": "파일 편집",
        "edit group": "그룹 편집",
        "edit in tct web": "TCT web에서 편집",
        "edit in tct web disabled": "TCT web에서의 편집 기능은 프리미엄 기업 계정에서만 이용 가능합니다.",
        "edit product code": "제품 코드 편집",
        "edit role": "역할 편집",
        "edit smart group": "스마트 그룹 편집",
        "edit user": "사용자 편집",
        "Empty": "빈",
        "enter here": "여기를 클릭하세요",
        "exception_info": "예외 정보",
        "Executing": "실행 중",
        "expand menu": "메뉴 확장",
        "Expired": "만료됨",
        "Factory": "",
        "Failed": "실패",
        "file": "파일",
        "file data": "파일 데이터",
        "files": "파일",
        "file deleted": "파일이 삭제되었습니다",
        "firmware": "펌웨어",
        "firmware_36": "펌웨어 (FM36)",
        "firmware_64": "펌웨어 (FMB64)",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "펌웨어 번들",
        "fw_bundle_ble": "번들 - BLE 펌웨어",
        "fw_bundle_ble_dtb": "번들 - BLE DTB",
        "fw_bundle_can": "번들 - CAN 펌웨어",
        "fw_bundle_can_dtb": "번들 - CAN DTB",
        "fw_bundle_dtb": "번들 - 메인 DTB",
        "fw_bundle_mainfw": "번들 - 메인 펌웨어",
        "generic": "",
        "global_configuration": "글로벌 구성",
        "global_firmware": "글로벌 펌웨어",
        "gnssm_download_assistant": "GNSS-M 다운로드 어시스턴트",
        "gnssm_firmware": "GNSS-M 펌웨어",
        "group": "그룹",
        "groups": "기기 그룹",
        "hardware key": "하드웨어 키",
        "id": "ID",
        "id_collection_file": "ID 수집 파일",
        "imei restriction": "IMEI 제한",
        "Inactive": "비활성",
        "Invalid": "잘못된",
        "invalid model": "잘못된 모델",
        "invalid model_name": "잘못된 모델",
        "InvitationExpired": "초대 기간 만료",
        "InvitationPending": "초대 대기 중",
        "Legacy": "레거시",
        "legacy model": "레거시 모델",
        "legacy model_platform": "레거시 플랫폼",
        "legacy platform": "레거시 플랫폼",
        "license has expired": "라이선스가 만료되었습니다",
        "loading": "로딩 중",
        "log": "로그",
        "MainConfiguration": "",
        "main configuration": "",
        "manual": "매뉴얼",
        "ManualGeofenceList": "",
        "manual geofence list": "수동 지오펜스 시나리오 목록",
        "manual_geofence_list": "수동 지오펜스 시나리오 목록",
        "manual_geofence_scenarios": "",
        "meig_modem_firmware": "MeiG 모뎀 펌웨어",
        "menu": "메뉴",
        "modem version": "모뎀 버전",
        "netprisma_modem_firmware": "NETPRISMA 모뎀 펌웨어",
        "nmea_log": "NMEA 로그",
        "no": "없음",
        "no results": "초기 결과 없음",
        "no results description": "{{name}}가 FOTA WEB에 업로드되는 즉시, 여기서 데이터를 확인할 수 있습니다",
        "not assigned": "미배정",
        "not assigned configuration_file_id": "구성되지 않음",
        "not assigned current_configuration": "구성되지 않음",
        "not assigned current_firmware": "펌웨어 미할당",
        "not assigned firmware_file_id": "펌웨어 미할당",
        "not assigned group_id": "그룹 미지정",
        "not assigned model": "모델 미지정",
        "not assigned spec_id": "Spec ID 미지정",
        "not assigned task_type": "할당되지 않은 업무 유형",
        "obd_chip_firmware": "FM OBD 칩 펌웨어",
        "obd chip firmware version": "OBD 칩 펌웨어 버전",
        "Offline": "오프라인",
        "offline licenses": "오프라인 라이선스",
        "Online": "온라인",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "또는",
        "other": "기타",
        "Pending": "보류 중",
        "Pending approval": "승인 대기 중",
        "permission disabled": "사용 중지됨",
        "permission enabled": "활성화됨",
        "productCodes": "제품 코드",
        "psub": "구독 파일",
        "quectel_fw": "퀘이텔 모뎀 펌웨어 (quectel_fw)",
        "quectel_modem_firmware": "퀘이텔 모뎀 펌웨어",
        "resend invite": "초대장을 다시 보내기",
        "restricted": "제한됨",
        "retry": "재시도",
        "roles": "역할 및 권한",
        "Running": "실행 중",
        "RxAutoscan": "자동 스캔 CAN 파일 수신",
        "RxBlackBox": "블랙박스 수신",
        "RxBluetoothAuthorizationList": "블루투스 인증 목록 수신",
        "RxCanDebugLog": "CAN 디버그 로그 수신",
        "RxCarrierExtractions": "Carrier extractions 다운로드",
        "RxCarrierLoggerFiles": "Carrier 온도 로거 파일 다운로드",
        "RxConfiguration": "구성 수신",
        "RxCrashDump": "크래시 덤프 로그 수신",
        "RxExceptionInfo": "예외 정보 수신",
        "RxLog": "내부 로그 수신",
        "RxManualGeofenceList": "수동 지오펜스 시나리오 목록 수신",
        "RxNmeaLog": "NMEA 로그 수신",
        "RxOneWireAuthorizationList": "1-Wire 인증 목록 수신",
        "RxWdLog": "워치독(WD) 로그 수신",
        "select company": "회사 선택",
        "SetBindSim": "현재 SIM 카드와 기기 연결",
        "SetBluetoothPassword": "",
        "SetDisableFeature": "기능 비활성화",
        "SetEnableFeature": "기능 활성화",
        "SetForceLockSim": "강제 잠금 SIM",
        "SetUnbindSim": "SIM 카드와 연결된 기기 분리",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "상태",
        "task details": "업무 세부사항",
        "task groups": "업무 그룹",
        "tasks": "업무 그룹",
        "tasksCompatibility": "업무 호환성",
        "task type": "업무 유형",
        "Tct": "",
        "time zone": "시간대",
        "total": "전체",
        "tutorials": "튜토리얼",
        "TxAdasFirmware": "ADAS 펌웨어 업로드",
        "TxAgpsMt3333": "AGPSM 파일 전송",
        "TxAgpsQuectelL89": "AGPSQ 파일 전송",
        "TxAutoscanCanConfiguration": "자동 스캔 OEM 파일 업로드",
        "TxBleFirmware": "BLE 펌웨어 업로드",
        "TxBlueNrgFirmware": "BlueNrg 펌웨어 업로드",
        "TxBluetoothAuthorizationList": "블루투스 인증 목록 업로드",
        "TxBundleBle": "BLE 펌웨어 업로드",
        "TxBundleBleDtb": "BLE DTB 업로드",
        "TxBundleCan": "CAN 펌웨어 업로드",
        "TxBundleCanDtb": "CAN DTB 업로드",
        "TxBundleDtb": "메인 DTB 업로드",
        "TxBundleFirmware": "메인 펌웨어 업로드",
        "TxCanAdapterModeChange": "외부 CAN 어댑터 모드 변경",
        "TxCanAdapterModeChangeInternal": "내부 CAN 어댑터 모드 변경",
        "TxCanAdapterUpdate": "CAN 어댑터 펌웨어 업로드",
        "TxCanAdapterUpdateInternal": "내부 CAN 어댑터 업데이트",
        "TxCanChipFirmware": "FMXY50 CAN 칩 펌웨어 업로드",
        "TxCanConfiguration": "OEM 파일 업로드",
        "TxCarrierAdvanceFirmware": "Carrier Advance 펌웨어 업데이트",
        "TxCarrierAdvanceSettings": "Carrier Advance 설정 업데이트",
        "TxCarrierApxFirmware": "Carrier APX 펌웨어 업데이트",
        "TxCarrierApxSettings": "Carrier APX 설정 업데이트",
        "TxConfiguration": "업로드 구성",
        "TxDsmFirmware": "DSM 펌웨어 업로드",
        "TxDtb": "DTB 업로드",
        "TxFirmware": "펌웨어 업로드",
        "TxFirmwareBundle": "펌웨어 번들 컨테이너 업로드",
        "TxFirmwareBundleParts": "펌웨어 번들 업로드",
        "TxFotaCertificate": "FOTA 인증서 업데이트",
        "TxGenericFile": "",
        "TxGNSSMDownloadAssistant": "GNSS-M 업로드 다운로드 어시스턴트",
        "TxGNSSMFirmware": "GNSS-M 펌웨어 업로드",
        "TxManualGeofenceList": "수동 지오펜스 시나리오 목록 업로드",
        "TxMeigModemDeltaFirmware": "MeiG Delta 모뎀 펌웨어 업로드",
        "TxNetprismaModemDeltaFirmware": "NETPRISMA 델타 모뎀 펌웨어 업로드",
        "TxObdChipFirmware": "OBD 칩 업데이트",
        "TxObdConfig": "OBD 구성 파일 전송",
        "TxOneWireAuthorizationList": "1-Wire 인증 목록 업로드",
        "TxPSub": "구독 파일 전송",
        "TxQuectelModemDeltaFirmware": "Quectel Delta 모뎀 펌웨어 업로드",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "사용자 TLS 인증서 업로드",
        "users": "사용자",
        "Unknown": "알 수 없음",
        "unknown": "알 수 없음",
        "unknown model_platform": "알 수 없는 플랫폼",
        "unknown origin": "",
        "unknown platform": "알 수 없는 플랫폼",
        "unrestricted": "제한 없음",
        "Verifying": "검증",
        "vin": "차량 식별 번호(VIN)",
        "vip status": "VIP 등급",
        "wd_log": "WD 로그",
        "yes": "예"
    },
    "Maintenance": {
        "title": "잠시만 기다려 주세요! 현재 시스템 점검 중입니다."
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}}이(가) 서버 오류로 인해 실패했습니다.",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "선택한 모든 작업을 취소할 권한이 없습니다. 일부 작업은 다른 회사의 리소스와 연결되어 있습니다.",
            "Cancel tasks action failed. No resources found.": "선택한 조건과 일치하는 작업이 없습니다. 업무 선택을 다시 검토한 후 다시 시도해 주세요.",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "회사 \"{{SourceCompanyName}}\" ({{SourceCompanyId}})가 \"{{TargetCompanyName}}\" ({{TargetCompanyId}})로 합병되었습니다.",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "회사 병합이 실패했습니다. 설정 또는 권한 불일치로 인해 \"{{SourceCompanyId}}\"와 \"{{TargetCompanyId}}\" 회사를 병합할 수 없습니다.",
            "Create device group tasks action failed. No resources found.": "스마트 그룹에 대한 업무 생성에 실패했습니다. 파일을 재할당해 보십시오.",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "{{GroupId}} 디바이스 그룹 ID의 디바이스에 대해 {{CreatedTaskCount}}개의 작업이 생성되었습니다.",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "선택한 모든 기기에 대한 업무 생성 권한이 없습니다. 일부 기기는 다른 회사에 속합니다.",
            "Create tasks action failed. No resources found.": "선택한 조건에 맞는 장치가 없습니다. 장치 선택을 다시 확인한 후 재시도해 주세요.",
            "Create tasks action failed. No resources processed.": "선택한 장치 처리에 실패했습니다. 업무 그룹을 다시 생성해 보십시오.",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "선택한 모든 회사를 삭제할 권한이 없습니다. 일부 회사는 귀하의 직접 관리 대상이 아닙니다.",
            "Delete companies action failed. No resources found.": "선택한 조건에 맞는 회사가 없습니다. 회사 선택을 다시 검토한 후 다시 시도해 주세요.",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "선택한 모든 파일을 삭제할 권한이 없습니다. 일부 파일은 다른 회사의 리소스와 연결되어 있습니다.",
            "Delete files action failed. No resources found.": "선택한 조건에 맞는 파일이 없습니다. 파일 선택을 다시 확인하고 다시 시도해 주세요.",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "선택한 모든 장치 그룹을 삭제할 권한이 없습니다. 일부 장치 그룹에는 서로 다른 회사의 리소스가 포함되어 있습니다.",
            "Delete groups action failed. No resources found.": "선택한 조건에 맞는 장치 그룹이 없습니다. 장치 그룹 선택을 다시 확인한 후 재시도해 주세요.",
            "Delete product codes action failed. No resources found.": "선택하신 제품 코드가 없습니다. 제품 코드 선택을 다시 확인하시고 재시도해 주세요.",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "선택한 모든 사용자를 삭제할 권한이 없습니다. 일부 사용자는 다른 회사에 소속되어 있습니다.",
            "Delete users action failed. No resources found.": "선택한 조건에 맞는 사용자가 없습니다. 사용자 선택을 다시 확인하시고 재시도해 주세요.",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{DevicesCount}} 개의 기기가 \"{{Filename}}\"으로 내보내졌습니다.",
            "{{DevicesCount}} device(s) imported.": "{{DevicesCount}}개의 기기가 가져왔습니다.",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "{{DevicesProcessedCount}}개의 기기 처리됨, {{TasksCreatedCount}}개의 업무 생성됨.",
            "Export devices action failed. No resources found.": "선택한 조건에 맞는 장치가 없습니다. 장치 선택을 다시 확인한 후 재시도해 주세요.",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "{{BatchId}} 업무 그룹에서 {{FailedTaskCount}}개의 작업이 보류 상태로 되돌아갔습니다.",
            "Invalid request scope. Resources must belong to single root.": "유효하지 않은 요청 범위입니다. 리소스는 단일 루트에 속해야 합니다.",
            "Move device group action failed. No resources found.": "",
            "{{ProcessedCount}} companies deleted.": "{{ProcessedCount}}개 기업 삭제됨.",
            "{{ProcessedCount}} device group(s) deleted.": "{{ProcessedCount}}개의 기기 그룹이 삭제되었습니다.",
            "{{ProcessedCount}} device attribute(s) updated.": "{{ProcessedCount}}개의 기기 속성이 업데이트되었습니다.",
            "{{ProcessedCount}} device model(s) deleted.": "{{ProcessedCount}}개의 기기 모델이 삭제되었습니다.",
            "{{ProcessedCount}} device(s) updated.": "{{ProcessedCount}}개의 기기가 업데이트되었습니다.",
            "{{ProcessedCount}} file(s) deleted.": "{{ProcessedCount}}개의 파일이 삭제되었습니다.",
            "{{ProcessedCount}} product code(s) deleted.": "{{ProcessedCount}}개의 제품 코드가 삭제되었습니다.",
            "{{ProcessedCount}} task(s) canceled.": "{{ProcessedCount}}개의 작업이 취소되었습니다.",
            "{{ProcessedCount}} task(s) updated.": "{{ProcessedCount}}개의 작업이 업데이트되었습니다.",
            "{{ProcessedCount}} user(s) deleted.": "{{ProcessedCount}}명의 사용자가 삭제되었습니다.",
            "Retry tasks action failed. No resources found.": "선택한 조건과 일치하는 작업이 없습니다. 업무 선택을 다시 검토한 후 다시 시도해 주세요.",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "선택한 모든 기기를 전송할 권한이 없습니다. 일부 기기는 다른 회사에 속합니다.",
            "Transfer devices action failed. No resources found.": "선택한 조건에 맞는 장치가 없습니다. 장치 선택을 다시 확인한 후 재시도해 주세요.",
            "Transfer devices action failed. No resources processed.": "선택한 장치 처리에 실패했습니다. 장치를 다시 전송해 보십시오.",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "{{TotalDevicesToTransfer}} 대의 장치 중 {{TransferredDevicesCount}} 대가 전송되었습니다.",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "선택한 모든 기기를 업데이트할 권한이 없습니다. 일부 기기는 다른 회사에 속합니다.",
            "Update devices action failed. No resources found.": "선택한 조건에 맞는 장치가 없습니다. 장치 선택을 다시 확인한 후 재시도해 주세요.",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "선택한 모든 장치의 속성을 업데이트할 권한이 없습니다. 일부 장치는 다른 회사에 속합니다.",
            "Update devices attributes action failed. No resources found.": "선택한 조건에 맞는 장치가 없습니다. 장치 선택을 다시 확인한 후 재시도해 주세요.",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "선택한 모든 작업을 업데이트할 권한이 없습니다. 일부 작업은 서로 다른 회사의 리소스와 연결되어 있습니다.",
            "Update tasks action failed. No resources found.": "선택한 조건과 일치하는 작업이 없습니다. 업무 선택을 다시 검토한 후 다시 시도해 주세요.",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": ""
        },
        "no notifications": "알림 없음",
        "notifications": "알림",
        "notifications will be listed": "모든 새로운 알림은 여기에 표시됩니다",
        "remove notification": "알림 제거",
        "see previous notifications": "이전 알림 보기",
        "timestamps": {
            "days ago": "{{days}}일 전",
            "hours ago": "{{hours}}시간 전",
            "minutes ago": "{{minutes}}분 전",
            "moments ago": "방금 전"
        },
        "title": {
            "BackgroundActionFailed": "업무 실패",
            "CompaniesSuccessfullyDeleted": "기업들이 성공적으로 삭제했습니다",
            "CompanyBulkDeleteFailed": "회사 삭제 중 오류가 발생했습니다",
            "CompanyLevelChanged": "회사 수준 변경됨",
            "CompanyLevelDowngradeReminder": "예정된 회사 차원의 다운그레이드",
            "CompanyMergeFailed": "회사 병합 중 오류가 발생했습니다",
            "CompanySuccessfullyMerged": "기업 합병 성공",
            "DeviceAttributesSuccessfullyUpdated": "기기 속성 업데이트 완료",
            "DeviceBulkAttributeUpdateFailed": "기기 속성 업데이트 중 오류가 발생했습니다",
            "DeviceBulkUpdateFailed": "장치 업데이트 중 오류가 발생했습니다",
            "DeviceExportFailed": "장치 내보내기 중 오류가 발생했습니다",
            "DeviceGroupMoveFailed": "",
            "DeviceGroupsSuccessfullyDeleted": "기기 그룹이 성공적으로 삭제되었습니다",
            "DeviceGroupSuccessfullyMoved": "",
            "DeviceGroupTasksCreateFailed": "스마트 그룹 업무 생성 중 오류가 발생했습니다",
            "DeviceGroupTasksSuccessfullyCreated": "스마트 그룹 작업이 성공적으로 생성되었습니다",
            "DeviceModelBulkDeleteFailed": "기기 모델 삭제 중 오류가 발생했습니다",
            "DeviceModelsSuccessfullyDeleted": "장치 모델이 성공적으로 삭제되었습니다",
            "DevicesSuccessfullyTransferred": "장치 성공적으로 이전됨",
            "DevicesSuccessfullyUpdated": "장치 업데이트 성공",
            "DeviceTransferFailed": "기기 이체 중 오류가 발생했습니다",
            "ExportFailed": "리소스 내보내기가 실패했습니다",
            "ExportSucceeded": "장치 성공적으로 내보냄",
            "FailedTasksRetryFailed": "업무 재시도 중 오류가 발생했습니다",
            "FailedTasksSuccessfullyRetried": "작업이 성공적으로 재시도되었습니다",
            "FileBulkDeleteFailed": "파일 삭제 중 오류가 발생했습니다",
            "FilesSuccessfullyDeleted": "파일 삭제 성공",
            "GroupBulkDeleteFailed": "기기 그룹 삭제 중 오류가 발생했습니다",
            "ImportFailed": "리소스 가져오기 실패",
            "ImportSucceeded": "장치 성공적으로 가져옴",
            "ProductCodeBulkDeleteFailed": "제품 코드 삭제 중 오류가 발생했습니다",
            "ProductCodesSuccessfullyDeleted": "제품 코드 성공적으로 삭제됨",
            "ResourceUpdateFailed": "리소스 업데이트 실패",
            "ResourceUpdateSucceeded": "리소스 업데이트 성공",
            "RoleBulkDeleteFailed": "역할 삭제 중 오류가 발생했습니다",
            "RolesSuccessfullyDeleted": "역할이 성공적으로 삭제되었습니다",
            "TaskBulkCancelFailed": "업무 취소 중 오류가 발생했습니다",
            "TaskBulkCreateFailed": "업무 그룹 생성 중 오류가 발생했습니다",
            "TaskBulkUpdateFailed": "업무 업데이트 중 오류가 발생했습니다",
            "TaskGroupSuccessfullyCreated": "업무 그룹이 성공적으로 생성되었습니다",
            "TasksPropagationFailed": "업무 전파 업무 실패",
            "TasksPropagationSucceeded": "업무 전파 작업이 성공했습니다",
            "TasksPropagationWarning": "업무 전파 작업이 경고와 함께 종료되었습니다",
            "TasksSuccessfullyCanceled": "작업이 성공적으로 취소되었습니다",
            "TasksSuccessfullyUpdated": "작업이 성공적으로 업데이트되었습니다",
            "UserBulkDeleteFailed": "사용자 삭제 중 오류가 발생했습니다",
            "UserExpireReminder": "",
            "UsersSuccessfullyDeleted": "사용자가 성공적으로 삭제됨"
        }
    },
    "Permission actions": {
        "Access": "TCT 통합",
        "Create": "생성",
        "Delete": "삭제",
        "Download": "다운로드",
        "Export": "내보내기",
        "Merge": "병합",
        "Read": "읽기",
        "Retry": "재시도",
        "SecretsRead": "",
        "TctWebAccess": "TCT web",
        "Transfer": "이체",
        "Unlock": "잠금 해제",
        "Update": "업데이트"
    },
    "Permission groups": {
        "company": "기업",
        "device": "기기",
        "device group": "기기 그룹",
        "file": "파일",
        "role": "역할",
        "task": "업무",
        "task group": "업무 그룹",
        "token": "토큰",
        "user": "사용자"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "기본 회사 등급 사용자에게는 이 옵션이 비활성화됩니다.",
                "token list": "기본 회사 수준의 사용자에게는 API 통합 토큰이 비활성화됩니다."
            },
            "custom_role_support": {
                "create role": "이 기능은 프리미엄 회사 등급을 보유한 사용자만 이용할 수 있습니다.",
                "edit role": "이 기능은 프리미엄 회사 등급 사용자에게만 제공됩니다. 기존에 생성된 사용자 정의 역할은 삭제될 수 있습니다.",
                "edit user": "이 기능은 프리미엄 회사 등급 사용자에게만 제공됩니다. 기존에 할당된 사용자 정의 역할은 제거될 수 있습니다."
            },
            "task_schedule_support": {
                "table head": "이 기능은 Standard 및 Premium 회사 등급 사용자에게만 제공됩니다. 기존에 추가된 예약 작업은 계속 실행됩니다."
            }
        },
        "general message": "이 기능은 Standard 및 Premium 회사 등급을 가진 사용자만 사용할 수 있습니다.",
        "resource_limit_settings": {
            "tasks_per_group": "한 번에 {{limitCount}}개 이상의 기기에 대한 작업을 생성할 수 없습니다."
        }
    },
    "Search": {
        "code": "코드",
        "description": "설명",
        "email": "이메일",
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "model": "모델",
        "name": "이름",
        "product code": "제품 코드",
        "role name": "역할 이름",
        "serial": "일련 번호",
        "search by": "검색",
        "search company name": "회사명 검색"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "2단계 인증을 비활성화하려고 합니다. 이로 인해 FOTA WEB 계정이 안전하지 않을 수 있습니다. 계속하시겠습니까?",
                    "title": "정말 확인하시겠습니까?"
                },
                "send email code": {
                    "enter code": "보안상의 이유로, 이메일 확인을 위해 코드를 입력해 주세요."
                },
                "send otp code": {
                    "description": "인증 앱으로 6자리 코드가 전송되었습니다. 보안상 아래 필드에 생성된 코드를 입력해 주세요.",
                    "no access": {
                        "authenticator": "해당 계정에 연결된 인증 앱에 더 이상 접근할 수 없는 경우, 2단계 인증을 비활성화하려면 비밀번호 변경이 필요합니다.",
                        "email": "해당 계정에 연결된 이메일 계정에 더 이상 접근할 수 없는 경우, 다단계 인증을 비활성화하려면 비밀번호 변경이 필요합니다."
                    }
                },
                "title": "2단계 인증 비활성화"
            },
            "get email code": {
                "description": "다음 화면에서 해당 코드를 사용하여 계정을 인증하세요.",
                "description modal": "해당 코드를 사용하여 계정을 인증하세요.",
                "title": "\"코드 보내기\"를 누르면 고유 코드가 <1>{{email}}</1>으로 전송됩니다."
            },
            "get secret code": {
                "description": "이 과정을 완료하려면 인증기 모바일 앱이 필요합니다. 예를 들어 다음 중 하나를 사용하십시오:"
            },
            "select authentication type": {
                "authentication app description": "Microsoft Authenticator 또는 Google Authenticator와 같은 앱에서 고유 코드를 획득하세요.",
                "description": "계정 및 고객 데이터 보안을 위해 다음 옵션 중 하나로 2단계 인증을 설정해 주십시오.",
                "description modal": "원하는 인증 방식을 선택하세요.",
                "email": "이메일",
                "email description": "로그인 시마다 일회용 인증 코드를 이메일로 발송해 드립니다.",
                "recommended": "추천",
                "title": "모든 FOTA WEB 사용자에게 2단계 인증(2FA)이 필수입니다.",
                "title modal": "인증 방법 선택"
            },
            "send email code": {
                "description": "아래 필드에 코드를 입력하고 \"확인\"을 눌러 진행하십시오.",
                "enter code": "이메일 확인을 위해 코드를 입력해 주세요.",
                "title": "고유 코드가 <1>{{email}}</1>으로 발송되었습니다.",
                "verification code": "인증 코드"
            },
            "send otp code": {
                "click to scan code": "QR 코드를 스캔하려면 여기를 클릭하세요",
                "click to type code": "여기를 클릭하여 코드를 직접 입력하세요",
                "incorrect code": "잘못된 코드",
                "scan QR code": "앱에 QR 코드를 스캔하세요",
                "six digit code": "앱에서 생성된 6자리 코드",
                "title": "이 과정을 완료하려면 인증기 모바일 앱이 필요합니다. 예를 들어: <1>Microsoft Authenticator</1> 또는 <2>Google Authenticator</2> 등이 있습니다.",
                "type text code": "앱에 텍스트 코드를 입력하세요"
            },
            "settings": {
                "description": "2단계 인증은 사용자가 알고 있는 정보(비밀번호)와 사용자가 소유한 정보(휴대폰, 보안 키, 이메일)를 통해 신원을 확인하는 추가 보안 계층입니다.",
                "disabled": "사용 중지됨",
                "enabled": "활성화됨",
                "title": "2단계 인증"
            },
            "success message": {
                "alert": "2단계 인증이 성공적으로 활성화되었습니다.",
                "description": "이메일과 비밀번호로 로그인할 때마다 인증 코드를 요청합니다.",
                "title": "2단계 인증을 성공적으로 활성화했습니다.",
                "title modal": "2단계 인증 지원!"
            },
            "title": {
                "authentication app": "인증 앱",
                "authentication email": "인증 이메일",
                "is enabled": "2단계 인증 지원.",
                "protect your account": "FOTA WEB 계정 보호"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "비밀번호 변경",
            "enter current password": "현재 비밀번호 입력",
            "enter new password": "새 비밀번호 입력",
            "hide password": "비밀번호 숨기기",
            "repeat new password": "새 비밀번호를 다시 입력하세요",
            "rules": {
                "lowercase letter": "소문자(a-z) 하나 이상",
                "minimum characters": "최소 12자",
                "new and current passwords must not match": "새 비밀번호와 기존 비밀번호는 동일할 수 없습니다",
                "new passwords must match": "새 비밀번호는 기존 비밀번호와 일치해야 합니다",
                "number": "최소 한 개의 숫자",
                "passwords must match": "비밀번호는 반드시 일치해야 합니다",
                "special symbol": "최소 하나의 특수 기호 (!@#$%^&*()-_=+)",
                "uppercase letter": "대문자(A-Z)가 최소 한 개 이상 포함되어야 합니다"
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": "비밀번호 표시"
        },
        "recovery codes": {
            "banner description": "",
            "banner title": "",
            "checkbox title": "",
            "download error message": "",
            "first step description": "",
            "first step title": "",
            "input field title": "",
            "print error message": "",
            "second step description": "",
            "second step title": "",
            "settings": {
                "title": "",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": ""
    },
    "Statistics": {
        "table statistics": "테이블 통계",
        "statistics message": "테이블 필터는 아래에 표시되는 통계에 영향을 미칩니다",
        "activity": "활동",
        "model": "모델",
        "firmware": "펌웨어",
        "configuration": "구성",
        "statistics": "통계"
    },
    "Table": {
        "1_wire_authorization": "1-Wire 인증",
        "access group": "",
        "access groups": "",
        "access level": "접근 수준",
        "accessories": "액세서리",
        "action": "활동",
        "action date": "활동 날짜",
        "assigned package": "할당된 패키지",
        "attempt count": "시도 횟수",
        "attribute": "속성",
        "attributes": "속성",
        "auto sync": "",
        "batch id": "배치 ID",
        "ble_dtb": "BLE DTB",
        "ble_fw": "BLE 펌웨어",
        "bluetooth_authorization": "블루투스 인증",
        "bootloader": "부트 로더",
        "can_adapter": "CAN 어댑터",
        "can adapter name": "CAN 어댑터 이름",
        "can bootstring": "부트스트링",
        "can oem file package": "OEM 파일 패키지",
        "can oem file vehicle": "OEM 파일 차량",
        "can package": "CAN 패키지",
        "can program number": "CAN 프로그램 번호",
        "can software date": "CAN 소프트웨어 데이터",
        "can type": "CAN 타입",
        "carrier module id": "모듈 ID",
        "carrier revision": "개정판",
        "carrier serial id": "시리얼 ID",
        "carrier settings filename": "설정 파일명",
        "carrier unit status": "상태",
        "carrier unit type": "유닛 유형",
        "changed at": "변경됨",
        "change origin": "",
        "changes": "변경들",
        "checkbox disabled": {
            "role": "정적 역할은 편집하거나 삭제할 수 없습니다."
        },
        "child company": "<1>{{parentCompany}}</1><0>의 자회사</0>",
        "child companies": "자회사",
        "code": "코드",
        "company": "회사",
        "company hierarchy": "회사 계층",
        "company name": "회사명",
        "compatibility": "호환성",
        "configuration": "구성",
        "configuration details": "구성 세부사항",
        "configuration type": "",
        "created at": "창조 시간",
        "created by": "창조자",
        "date": "날짜",
        "description": "설명",
        "device details": "기기 세부",
        "device company": "기기 회사",
        "device description": "기기 설명",
        "device group": "기기 그룹",
        "device imei": "기기 IMEI",
        "device model": "기기 모델",
        "device seen at": "장치 확인 위치:",
        "device serial": "기기 일련 번호",
        "devices": "기기",
        "devices count": "기기 수",
        "Done": "완료",
        "download at": "",
        "download file": "파일 다운로드",
        "dtb": "DTB",
        "edit file": "파일 편집",
        "email": "이메일",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "업무 그룹이 생성되는 즉시, 여기에서 목록을 확인할 수 있습니다",
                    "changes": "변경들 사항이 적용되자마자 여기에서 목록을 보일 수 있습니다",
                    "companies": "기업이 생성되는 즉시, 여기에서 목록을 확인할 수 있습니다",
                    "configurationChanges": "",
                    "desktopLicenses": "desktop 라이선스가 생성되는 즉시, 여기에서 목록을 확인할 수 있습니다",
                    "devices": "장치가 FOTA WEB에 업로드되는 즉시, 여기에서 목록을 확인할 수 있습니다",
                    "files": "파일이 업로드되는 즉시, 여기에서 목록을 확인할 수 있습니다",
                    "groups": "그룹이 생성되는 즉시, 여기에서 목록을 확인할 수 있습니다",
                    "offlineLicenses": "오프라인 라이선스가 생성되는 즉시, 여기에서 목록을 확인할 수 있습니다",
                    "permissions": "사용자에게 권한이 부여되는 즉시, 여기에서 목록을 확인할 수 있습니다",
                    "productCodes": "제품 코드가 생성되는 즉시, 여기에서 목록을 확인할 수 있습니다",
                    "roles": "역할이 생성되는 즉시, 여기에서 목록을 확인할 수 있습니다",
                    "tasks": "작업이 생성되는 즉시, 여기에서 목록을 확인할 수 있습니다",
                    "users": "사용자가 추가되는 즉시, 여기서 목록을 확인할 수 있습니다"
                },
                "title": {
                    "batches": "업무 그룹 테이블이 비어 있습니다",
                    "changes": "변경들 테이블이 비어 있습니다",
                    "companies": "회사 테이블이 비어 있습니다",
                    "configurationChanges": "",
                    "desktopLicenses": "Desktop 라이선스 테이블이 비어 있습니다",
                    "devices": "기기 테이블이 비어 있습니다",
                    "files": "파일 테이블이 비어 있습니다",
                    "groups": "그룹 테이블이 비어 있습니다",
                    "offlineLicenses": "오프라인 라이선스 테이블이 비어 있습니다",
                    "permissions": "권한 테이블이 비어 있습니다",
                    "productCodes": "제품 코드 테이블이 비어 있습니다",
                    "roles": "역할 테이블이 비어 있습니다",
                    "tasks": "업무 테이블이 비어 있습니다",
                    "users": "사용자 테이블이 비어 있습니다"
                }
            },
            "no permission": {
                "description": "접근 권한을 요청하려면 관리자에게 문의하십시오.",
                "title": "이 콘텐츠를 보려면 필요한 권한이 없습니다"
            },
            "no results found": {
                "description": "다른 키워드나 필터를 사용해 결과를 확인해 보세요",
                "title": "검색 결과 없음"
            },
            "button": {
                "add": {
                    "companies": "회사 생성",
                    "devices": "기기 추가",
                    "files": "파일 업로드",
                    "groups": "그룹 생성",
                    "productCodes": "제품 코드 추가",
                    "tasks": "업무 생성",
                    "users": "사용자 초대"
                },
                "reset view": "보기 재설정"
            }
        },
        "exausted autoscan limit": "자동 스캔 한도 소진까지",
        "exausted vin parsing limit": "VIN 파싱 한도 소진까지",
        "expiration": "만료",
        "expiration date": "만료일",
        "expires at": "만료일:",
        "expiry date": "만료일",
        "field": "현장",
        "file": "파일",
        "file id": "파일 ID",
        "files": "파일",
        "file type": "파일 유형",
        "filter by": "필터링 기준",
        "firmware": "펌웨어",
        "general": "일반",
        "general data": "일반 데이터",
        "gnss version": "GNSS 버전",
        "group": "그룹",
        "groups": "기기 그룹",
        "group vip status": "",
        "gsm number": "GSM 번호",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": "",
                "user sent configuration": ""
            },
            "platform": {
                "fmx platform": "<1>FMx 플랫폼</1> - FMx (FMB, FMU, FMC, FMM), FMT, FMP, TAT, MSP, TFT, TST, GH (GH5200) 및 TMT 모델.",
                "ft platform": "<1>FT 플랫폼</1> - FTx 및 ATx 모델.",
                "legacy platform": "<1>레거시 플랫폼</1> - FM(FM4001 및 FM3010 제외), FMA, GH(GH4000) 모델.",
                "title": "텔레매틱스 장치의 플랫폼 생성"
            },
            "visibility": "<1>내부</1>로 표시된 변경 사항은 클라이언트에게 표시되지 않습니다.</2><2>기기 변경 사항에는 표시되는 데이터와 숨겨진 데이터가 모두 포함될 수 있으므로, <1>외부 커뮤니케이션에서 스크린샷이나 세부 정보를 공유하지 마십시오</1>.</2>"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "IMSI",
        "info": "정보",
        "interface": "인터페이스",
        "invited by": "초대됨",
        "items": "항목",
        "last checked at": "마지막 확인일:",
        "last sign in": "마지막 로그인",
        "last status update": "마지막 상태 업데이트",
        "last used at": "마지막으로 사용된 시간",
        "license disabled": "사용 중지됨",
        "license enabled": "활성화됨",
        "license key": "라이선스 키",
        "license name": "",
        "links": "링크",
        "manual_geofence_scenarios": "수동 지오펜스 시나리오",
        "message": "메시지",
        "model": "모델",
        "model task type support": {
            "false": "지원되지 않음",
            "true": "지원됨"
        },
        "modem version": "모뎀 버전",
        "name": "이름",
        "new value": "새로운 가치",
        "next task": "다음 업무",
        "no changes": "변경 사항 없음.",
        "no company name": "회사명 없음",
        "no details": "상세 내용 없음",
        "no file": "파일 없음",
        "no imei available": "IMEI 정보가 없습니다",
        "no model": "모델 없음",
        "no parent company": "해당 기업은 모회사가 없습니다.",
        "no tasks": "해당 장치에는 작업이 없습니다.",
        "number": "번호",
        "obd": "OBD",
        "obd chip firmware version": "OBD 칩 펌웨어 버전",
        "of": "of",
        "offline licenses tab disabled": "비활성화된 desktop 라이선스에 대해서는 오프라인 라이선스를 사용할 수 없습니다.",
        "origin": "",
        "original value": "본래 가치",
        "other information": "기타 정보",
        "page of": "페이지",
        "parent company": "모회사",
        "permission count": "권한 수",
        "platform": "플랫폼",
        "Price": "가격",
        "product code": "제품 코드",
        "program number": "프로그램 번호",
        "property": "속성",
        "queue": "큐",
        "receiving company": "수취 회사",
        "revision": "개정판",
        "role": "역할",
        "role name": "역할 이름",
        "rows per page": "페이지당 행 수",
        "running": "실행 중",
        "schedule": "스케줄",
        "seen at": "확인됨",
        "select row": "세부 정보를 보려면 행을 선택하세요",
        "send sms": "SMS 발송",
        "serial": "일련 번호",
        "show details": {
            "desktopLicenses": "desktop 라이선스 세부 정보 보기",
            "devices": "기기 세부 정보 표시",
            "batches": "업무 그룹 세부 정보 표시",
            "tasks": "업무 세부 정보 표시",
            "companies": "회사 정보 보기"
        },
        "sim": "SIM",
        "size": "크기",
        "software date": "소프트웨어 날짜",
        "source company": "출처 회사",
        "spec_id": "Spec ID",
        "status": "상태",
        "status id": "상태 ID",
        "status name": "상태명",
        "supported task types": "지원되는 업무 유형",
        "synced at": "",
        "sync mode": "",
        "sync status": "",
        "table columns": "테이블 열",
        "target company": "대상 기업",
        "task id": "업무 ID",
        "task queue": "업무 대기열",
        "tasks": "업무",
        "task type": "업무 유형",
        "tct web support": "TCT web 지원",
        "total": "전체",
        "type": "유형",
        "updated at": "업데이트일",
        "updated by": "업데이트됨",
        "unknown": "알 수 없음",
        "user cannot be deleted": "사용자는 삭제할 수 없습니다.",
        "user cannot be edited": "사용자는 편집할 수 없습니다.",
        "user cannot delete himself": "사용자는 자신의 프로필을 삭제할 수 없습니다.",
        "user date statuses": {
            "expired": "만료됨",
            "expires": "만료됨",
            "never expires": "만료되지 않음",
            "sent": "Sent"
        },
        "user email": "사용자 이메일",
        "user invitation cannot be cancelled": "사용자 초대는 취소할 수 없습니다.",
        "user invitation cannot be resent": "사용자 초대는 재발송할 수 없습니다.",
        "user sent configuration": "",
        "user statuses": {
            "Active": "활성",
            "Inactive": "비활성",
            "InvitationExpired": "초대 기간 만료",
            "InvitationPending": "초대 대기 중"
        },
        "users": "사용자",
        "value from": "가치 제공",
        "value to": "가치 제공",
        "view all roles": "모두 보기 ({{count}})",
        "vin": "차량 식별 번호(VIN)",
        "vip status": "VIP 등급",
        "visibility": "가시성"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "",
            "disabled copy tooltip": "",
            "unknown": "",
            "unknown tooltip": ""
        },
        "device details": {
            "configuration": {
                "badge tooltips": {
                    "not supported": "",
                    "sync failed": "",
                    "syncing": ""
                },
                "configuration details": "",
                "mode descriptions": {
                    "Disabled": "",
                    "Enabled": "",
                    "ReportingOnly": ""
                },
                "mode not supported tooltip": "",
                "mode titles": {
                    "Disabled": "",
                    "Enabled": "",
                    "not supported": "",
                    "ReportingOnly": ""
                },
                "overview": "",
                "status titles": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "status tooltips": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "sync history": "",
                "sync status": ""
            }
        },
        "device group tasks": "",
        "group tasks": "",
        "number of devices": "",
        "permissions info": "권한 정보",
        "smart group files": "",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "액세서리 인터페이스 이름.",
                    "type": "연결된 액세서리 유형."
                },
                "can": {
                    "assigned package": "해당 기기에 할당된 OEM 패키지.",
                    "can oem file package": "마지막 연결 시 보고된 OEM 패키지.",
                    "can oem file vehicle": "마지막 연결 시 보고된 OEM 차량 구성 정보.",
                    "dtb": "",
                    "firmware": "CAN 펌웨어 버전."
                },
                "can_adapter": {
                    "can adapter name": "",
                    "can bootstring": "최신 수신된 CAN 어댑터 시작 문자열로, 현재 데이터와 어댑터의 프로그램 번호를 포함합니다.",
                    "program number": "CAN 어댑터의 프로그램 번호.",
                    "revision": "",
                    "software date": "CAN 어댑터의 소프트웨어 날짜.",
                    "type": "CAN 어댑터의 유형."
                },
                "configuration overview": {
                    "BluetoothAuthorizationList": "",
                    "MainConfiguration": "",
                    "ManualGeofenceList": "",
                    "OneWireAuthorizationList": ""
                },
                "configuration details": {
                    "1_wire_authorization": "마지막으로 전송된 1-Wire 인증 목록 파일 이름.",
                    "bluetooth_authorization": "마지막으로 전송된 블루투스 인증 목록 파일 이름.",
                    "main configuration": "마지막으로 전송된 메인 구성 파일 이름.",
                    "manual_geofence_scenarios": "마지막으로 전송된 수동 지오펜스 목록 파일 이름."
                },
                "general": {
                    "ble_dtb": "",
                    "ble_fw": "마지막 연결 시 보고된 BLE 펌웨어 버전.",
                    "bluetooth password": "",
                    "bootloader": "마지막 연결 시 보고된 장치 부트로더 버전.",
                    "company": "이 장치를 소유한 회사.",
                    "configuration": "마지막으로 전송된 구성 파일 이름.",
                    "description": "기기 설명(사용자 정의).",
                    "dtb": "마지막 연결 시 보고된 장치 트리 블롭의 버전.",
                    "firmware": "마지막 연결 시 보고된 장치 펌웨어 버전.",
                    "gnss version": "마지막 연결 시 보고된 GNSS 버전.",
                    "group": "이 기기가 할당된 기기 그룹.",
                    "product code": "기기 제품 코드.",
                    "serial": "장치 일련 번호"
                },
                "obd": {
                    "obd chip firmware version": "마지막 연결 시 보고된 OBD 칩 펌웨어 버전.",
                    "vin": "특정 자동차를 식별하는 고유한 17자리 코드."
                },
                "sim": {
                    "gsm number": "장치에 연결된 공중전화번호.",
                    "iccid": "SIM 카드를 식별하는 고유 일련번호.",
                    "imsi": "모바일 네트워크 가입자를 위한 고유 식별자."
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "",
                    "firmware": ""
                },
                "ft platform files": {
                    "1_wire_authorization_list": "",
                    "bluetooth_authorization_list": "",
                    "firmware": "",
                    "main configuration": ""
                }
            },
            "users": {
                "general": {
                    "created at": "사용자 생성 날짜 및 시간.",
                    "id": "사용자의 고유 ID.",
                    "invited by": "초대를 생성한 사용자의 이메일 주소.",
                    "role": "사용자에게 할당된 역할(들).",
                    "updated at": "마지막 사용자 업데이트 날짜 및 시간."
                }
            }
        },
        "user details": "사용자 세부 정보"
    },
    "Task groups": {
        "all": "전체",
        "bulk type": {
            "CompanyBulkDelete": "회사 삭제",
            "DeviceBulkCreate": "기기 추가",
            "DeviceBulkDelete": "기기 삭제",
            "DeviceBulkUpdate": "기기 업데이트",
            "FileBulkDelete": "파일 삭제",
            "GroupBulkDelete": "그룹 삭제",
            "TaskBulkCreate": "업무 생성",
            "TaskBulkUpdate": "업무 취소",
            "UserBulkDelete": "사용자 삭제"
        },
        "pending approval": "승인 대기 중",
        "already approved": "이미 승인됨",
        "no approval required": "승인 불필요",
        "total objects": "총 개체 수",
        "total tasks": "총 업무 수"
    },
    "Task status": {
        "0": "보류 중",
        "1": "실행 중",
        "2": "완료됨",
        "3": "오류가 포함된 상태로 완료됨",
        "4": "취소됨",
        "5": "실패",
        "6": "만료됨",
        "7": "승인 대기 중",
        "8": "검증",
        "task count": {
            "0": "대기 중인 업무",
            "1": "실행 중인 업무",
            "3": "오류 발생 업무 완료",
            "5": "실패한 업무"
        },
        "verified tooltip title": "작업이 성공적으로 완료되었으며 기기에서 확인되었습니다."
    },
    "Tasks": {
        "0": "작업이 대기열에 있으며 현재 대기 중입니다.",
        "1": "작업이 현재 실행 중입니다.",
        "2": "작업이 성공적으로 완료되었습니다.",
        "3": "작업은 완료되었으나 일부 오류가 발생했습니다.",
        "4": "작업이 취소되었습니다.",
        "5": "작업이 실패했습니다.",
        "6": "해당 작업은 지정된 시간 내에 완료되지 않았습니다."
    },
    "Tct": {
        "edit configuration": "구성 편집",
        "no editable configurations": "수정 가능한 구성은 업로드되지 않습니다",
        "open tct": "Open TCT web 버전",
        "open tct description": "TCT web 새 구성을 만들거나 FOTA WEB 기존 구성 파일을 편집할 수 있습니다.",
        "select configuration file": "TCT web 편집하려는 구성 파일을 선택하십시오.",
        "tct web": "TCT web",
        "tct web disabled description": "TCT web 버전은 프리미엄 기업 등급에서만 이용 가능합니다."
    },
    "Tutorial": {
        "buttons": {
            "exit": "",
            "finish": "",
            "get started": "",
            "next": "",
            "next feature": ""
        },
        "content": {
            "company selector": {
                "0": "",
                "1": "",
                "1-info": ""
            },
            "finish tutorial": "",
            "first time user": "",
            "task groups": {
                "desktop": {
                    "0": "",
                    "1": ""
                },
                "mobile": {
                    "0": "",
                    "1": ""
                }
            }
        },
        "titles": {
            "finish tutorial": "",
            "first time user": "",
            "tutorial mode": ""
        }
    }
}
